// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:32:25.150Z
// Property: Rivers Edge Townhomes & Lofts (ID: 6767906449167908)
// Collections: 20 amenities, 18 floorplans (live), 22 photos, 79 POIs, 2 reviews, 6 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167908",
  "property_external_id": "pf3rywt",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/lofts-at-rivers-edge-provo-ut/pf3rywt/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "rivers-edge-townhomes-&-lofts",
  "property_name": "Rivers Edge Townhomes & Lofts",
  "property_website_url": "https://www.liveatriversedgeprovo.com/",
  "property_domain": "https://www.liveatriversedgeprovo.com/",
  "property_address": "440 W River Vw Wy",
  "property_full_address": "440 W River Vw Wy, Provo, UT 84604",
  "property_address_1": "440 W River Vw Wy",
  "property_address_2": null,
  "property_address_city": "Provo",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84604",
  "property_address_country": "US",
  "property_address_county": "Utah County",
  "property_neighborhood_address": "Riverside",
  "property_address_latitude": "40.265804",
  "property_address_longitude": "-111.6677028",
  "property_email": null,
  "property_phone": "(385) 219-4939",
  "property_call_tracking_phone": "385-268-5242",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Riverfront living with room to choose.</strong> Explore modern studios through four-bedroom townhomes and lofts along the Provo River, with mountain views, smart-home comfort, and select attached-garage layouts—then schedule your tour to see Rivers Edge up close.</p>",
  "property_long_description": "<p><strong>Riverfront living with room to choose.</strong> At Rivers Edge Townhomes &amp; Lofts, you’re tucked along the Provo River in Riverside with mountain views, modern interiors, and a wide mix of <a href=\"/floor-plans\">studio, one-, two-, three-, and four-bedroom layouts</a>—including townhome-style options with attached garages and select homes with no neighbors above or below.</p><p>Days here can move from a workout in the fitness center to the yoga and spin studio, a swim at the resort-style pools, a soak in the year-round hot tubs, or a match on the pickleball courts. Inside, smart-home features, in-home washers and dryers, high-end appliances, open-concept layouts, air conditioning, and private balconies add comfort where it counts. Explore the full <a href=\"/amenities\">amenity collection</a> to see how much is built in.</p><p>Beyond the community, you’re near the Provo River Parkway Trail, Riverside Country Club, University Parkway, BYU, Utah Valley Hospital, The Shops at Riverwoods, University Place, Provo Canyon, and Sundance—putting dining, shopping, commuting routes, and outdoor recreation close to home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-0b08-707f-8bfc-14341ecf1fb2.webp",
  "property_featured_image_media": {
    "alt_text": "Tennis and pickleball courts with covered parking and apartment buildings in the background.",
    "public_id": "01a18981-0b08-707f-8bfc-14341ecf1fb2",
    "storage_key": "property/6767906449167908/01a18981-0b08-707f-8bfc-14341ecf1fb2.webp",
    "width": 2048,
    "height": 1536
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "247",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.76113360323887",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "55",
  "property_pet_restrictions": "Dogs and cats allowed. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats allowed. $300 pet fee and $300 refundable deposit per pet. Monthly pet rent: $50 per pet. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/amcloftsatriversedge",
  "property_resident_portal_url": null,
  "property_apply_now_url": "https://myrentalapplication.com/index/amcloftsatriversedge",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19e5d-dec6-70f8-a613-feaad134a0be.webp",
  "property_primary_logo_media": {
    "alt_text": "Rivers Edge Townhomes & Lofts logo",
    "public_id": "01a19e5d-dec6-70f8-a613-feaad134a0be",
    "storage_key": "property/6767906449167908/01a19e5d-dec6-70f8-a613-feaad134a0be.webp",
    "width": 1350,
    "height": 495
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19e5d-dec6-70f8-a613-feaad134a0be.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Rivers Edge Townhomes & Lofts logo",
    "public_id": "01a19e5d-dec6-70f8-a613-feaad134a0be",
    "storage_key": "property/6767906449167908/01a19e5d-dec6-70f8-a613-feaad134a0be.webp",
    "width": 1350,
    "height": 495
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19e5b-c7c4-7205-b0e9-ed1fbbc0835f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Rivers Edge Townhomes & Lofts logo",
    "public_id": "01a19e5b-c7c4-7205-b0e9-ed1fbbc0835f",
    "storage_key": "property/6767906449167908/01a19e5b-c7c4-7205-b0e9-ed1fbbc0835f.webp",
    "width": 1350,
    "height": 495
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "Studio - 4",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "1-3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "517 - 1,260 sq ft",
  "property_sqft_min": "517",
  "property_sqft_max": "1,260",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 8,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJodwuiQqbTYcRiMgswpm31g8",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Towns at River's Edge/Lofts at Rivers Edge",
  "property_home_romance_title": "Embrace a Life You’ll Love in Your New Apartment",
  "property_home_amenities_blurb": "<p><strong>Energy, ease, and Provo River views.</strong> Work out in high-end fitness centers, stretch into the yoga and spin studio, or head outside for four pickleball courts, a pool deck, and oversized hot tub. Lounge spaces and a standout clubhouse make downtime easy, while smart home features, in-home laundry, high-end appliances, private balconies, and mountain views bring extra comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits your space needs.</strong> Rivers Edge Townhomes &amp; Lofts offers studios through four-bedroom floor plans, including multi-level townhome-style options. Inside, select homes feature open-concept living, smart home technology, in-home washer and dryer, high-end appliances, air conditioning, private balconies, garage options, or no neighbors above or below.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at River’s Edge.</strong> Preview clean-lined kitchens, high-end appliance packages, open living spaces, private balconies with mountain views, and townhome-style layouts with added separation. Then picture the extras: pool and hot tub spaces, a relaxed clubhouse, game room, pickleball courts, and Provo River scenery just outside the frame.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Provo, naturally connected.</strong> At River’s Edge, Provo River Parkway trails, The Shops at Riverwoods, Provo Beach, AMC, dining, coffee, and dessert all sit close by—without the crowded feel. UTA Route 834 links the area to Provo Central Station, while canyon roads lead toward trailheads, ski days, and mountain-view drives. Explore the neighborhood, then schedule a tour to see the setting from here.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong> Rivers Edge Townhomes &amp; Lofts earns praise for its beautiful setting, responsive maintenance, and a leasing team that brings real care to the experience. Reviewers call out service that feels attentive from the first conversation, including friendly, knowledgeable support from Savanah and the team. Read more to see what stands out day to day in Riverside.</p>",
  "property_neighborhood_blurb": "<p><strong>Riverside keeps Provo close without feeling crowded.</strong> From River’s Edge, your day can spill naturally from the water to University Parkway: follow the Provo River Parkway for a shaded ride, meet for dinner at The Shops at Riverwoods, or make it an easy night with Provo Beach, AMC, coffee, sushi, barbecue, and dessert all in the same north Provo orbit. UTA Route 834 connects the Riverwoods area with Provo Central Station, while nearby canyon roads point you toward trailheads, ski days, and mountain-view drives. Back at home, the setting feels connected to the outdoors in the best way—river paths nearby, peaks in view, and <a href=\"/amenities\">community spaces</a> ready when you want to unwind. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it from here.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, right where you want it.</strong> At Rivers Edge Townhomes &amp; Lofts, your day can shift from a resort-style pool deck to an oversized hot tub, a high-energy workout, or a slower session in the dedicated yoga and spin studio. Private pickleball courts, game spaces, and an expansive clubhouse give you plenty of ways to enjoy time close to home, while the Provo riverfront setting and mountain views bring a scenic backdrop to everyday routines.</p><p>Inside, smart home technology, in-home washer and dryer, high-end appliances, air conditioning, and private balconies add ease where it matters most. Choose from loft or townhome-style <a href=\"/floor-plans\">floor plans</a>, including select homes with garage options or no neighbors above or below, then preview the spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Your next home starts here.</strong> Choose a studio to four-bedroom layout with open-concept design, smart home technology, in-home laundry, high-end appliances, air conditioning, and polished finishes. When you’re ready, start your online application for Rivers Edge Townhomes &amp; Lofts today.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong><br>Reach out to the leasing team at Rivers Edge Townhomes &amp; Lofts for help with floor plans, modern in-home features, resort-style amenities, or finding your way to our Riverside location near University Parkway.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you lease?</strong> Start here for quick answers about Rivers Edge Townhomes &amp; Lofts, from <a href=\"/floor-plans\">floor plan options</a> and modern in-home features to community living and policies. If you need anything more specific, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the way you want your space to feel.</strong> At Rivers Edge Townhomes &amp; Lofts, the floor plan collection gives you room to compare everything from streamlined studios and one-bedroom apartments to spacious two-, three-, and four-bedroom layouts, including townhome-style options with multiple levels.</p><p>As you browse available homes, look for the details that make daily living easier: open-concept living areas, smart home technology, in-home washer and dryer, high-end appliance packages, air conditioning, and select layouts with private balconies, garage options, or no neighbors above or below. Explore each card for current pricing and availability, then view the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the community in focus.</strong> Browse bright interiors with clean-lined kitchens, high-end appliance packages, open living spaces, and private balconies that frame mountain views. The gallery moves from polished apartment finishes to townhome-style layouts with extra separation, giving you a real feel for how each space lives.</p><p>Outside, picture poolside afternoons, hot-tub evenings, a clubhouse made for easy downtime, and game-room moments with pool, ping pong, and foosball. You’ll also catch the energy of the Provo River setting—pickleball courts, lounge spaces, and scenery that make the community feel connected to the outdoors. Explore the photos, then step into the details with <a href=\"/virtual-tours\">360 tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place at River’s Edge.</strong> Use the interactive map to explore available apartments, townhome-style layouts, and the Riverside setting near University Parkway—where Provo River scenery, mountain views, shopping, trails, and canyon access are all easy to picture from home.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, leashes, and everyday fresh air.</strong> At Rivers Edge Townhomes &amp; Lofts, your cat or dog is part of the routine—not an afterthought. Start the morning on your private balcony, take a leashed stroll through the riverside setting, or head out for longer walks along nearby paved trail connections when the day calls for extra miles. Back home, open-concept layouts, in-home laundry, smart home features, and modern finishes help pet life feel simple, while garage options add welcome convenience for gear, carriers, and quick departures.</p><p>Dogs and cats are welcome with a two-pet maximum per home; check the policy details on this page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which layout fits your day-to-day routine best.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at River’s Edge?</strong> Share the modern comfort, mountain views, and polished <a href=\"/floor-plans\">studio to four-bedroom layouts</a> with someone you know. Send a referral today and invite them to find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Rivers Edge.</strong><br>From modern comfort to everyday convenience, your resident portal keeps life streamlined. Log in to pay rent, submit maintenance requests, and manage your account—all in one easy place.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> At Rivers Edge Townhomes &amp; Lofts, reviews point to the details that matter most: a beautiful property, responsive support, and a team that makes the experience feel cared for from the start.</p><p>Residents highlight the leasing and maintenance teams as people who “truly care about their residents and their experience,” with special praise for Savanah as “friendly and knowledgeable.” As you read through the reviews below, you’ll get a clearer sense of the service, attention, and day-to-day experience that help make Rivers Edge stand out in Riverside.</p>",
  "property_created_at": "1793119899200",
  "property_scheduletour_blurb": "<p><strong>See River’s Edge in person.</strong><br>Tour open-concept layouts with smart home technology, in-home laundry, high-end appliances, polished finishes, and private balconies. Explore townhome-style options with attached garages and select homes with no neighbors above or below—then picture how modern comfort feels steps from the Provo River.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The Rivers Edge leasing team will be in touch soon to help with your next step. In the meantime, picture modern comfort near the Provo River, with open-concept layouts, smart home features, polished finishes, and resort-style spaces designed to make every day feel more complete.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layouts before you arrive.</strong> Take a self-guided 360 look at the apartment homes with virtual tours available for Yuba and Aspen one-bedroom layouts, plus Juniper and Stillwater two-bedroom layouts and additional 1BR and 2BR walkthroughs. Move room to room at your own pace, checking how the kitchen, dining, living, bedroom, and storage areas connect.</p><p>As you explore, look for the details that make these Provo apartments feel polished in person: open-concept living, bright windows, sleek kitchens, high-end appliances, modern finishes, and private balcony potential. When a layout catches your eye, compare more options on the <a href=\"/floor-plans\">floor plans</a> page, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see River’s Edge up close.</p>",
  "property_copyright": "2026 All Rights Reserved. Towns at River's Edge/Lofts at Rivers Edge",
  "property_seo_title_home": "Apartments & Townhomes in Provo, UT | Rivers Edge",
  "property_seo_description_home": "Studio to 4-bedroom apartments and townhomes in Provo, UT, along the Provo River. Resort-style pools, smart home tech, garages, and mountain views.",
  "property_seo_title_floorplans": "Studio-4 Bed Floor Plans in Provo, UT | Rivers Edge",
  "property_seo_description_floorplans": "Browse studio, 1, 2, 3, and 4-bedroom floor plans at Rivers Edge Townhomes & Lofts in Provo, UT, including townhomes with attached garage options.",
  "property_seo_title_amenities": "Resort-Style Amenities in Provo, UT | Rivers Edge",
  "property_seo_description_amenities": "Explore amenities at Rivers Edge in Provo: resort-style pools, hot tubs, a fitness center, yoga and spin studio, pickleball courts, and in-home washer/dryer.",
  "property_seo_title_gallery": "Photo Gallery | Rivers Edge Apartments in Provo, UT",
  "property_seo_description_gallery": "See photos of Rivers Edge Townhomes & Lofts in Provo, UT: modern interiors, townhomes, resort-style pools, the clubhouse, and Provo River mountain views.",
  "property_seo_title_virtualtours": "Virtual Tours | Rivers Edge Apartments in Provo, UT",
  "property_seo_description_virtualtours": "Tour Rivers Edge Townhomes & Lofts online. Explore studio to 4-bedroom apartments and townhomes in Provo, UT from home, then schedule an in-person visit.",
  "property_seo_title_interactivemap": "Interactive Site Map | Rivers Edge Provo Apartments",
  "property_seo_description_interactivemap": "Use the interactive map to find available apartments and townhomes at Rivers Edge in Provo, UT. Compare locations, floor plans, and views before you tour.",
  "property_seo_title_neighborhood": "Riverside Provo Neighborhood Guide | Rivers Edge",
  "property_seo_description_neighborhood": "Live in Provo’s Riverside neighborhood near BYU, The Shops at Riverwoods, Provo River trails, and University Pkwy. See what’s nearby Rivers Edge.",
  "property_seo_title_contact": "Contact Us | Rivers Edge Townhomes & Lofts, Provo",
  "property_seo_description_contact": "Contact Rivers Edge Townhomes & Lofts in Provo, UT. Ask about availability, studio to 4-bedroom floor plans, or schedule a tour with our leasing team.",
  "property_seo_title_faqs": "FAQs | Rivers Edge Townhomes & Lofts in Provo, UT",
  "property_seo_description_faqs": "Get answers about Rivers Edge Townhomes & Lofts in Provo, UT: leasing, pet policy, parking and garages, amenities, and how to schedule a tour.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Provo, UT",
  "property_seo_description_reviews": "Join Rivers Edge Townhomes & Lofts in Provo, UT! Experience stunning views and exceptional amenities in a vibrant community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Provo, UT",
  "property_seo_description_applynow": "Elevate your lifestyle at Rivers Edge Townhomes & Lofts in Provo, UT. Experience luxury living with stunning views and smart home features!",
  "property_seo_title_residentaccess": "Resident Access | Rivers Edge Townhomes & Lofts",
  "property_seo_description_residentaccess": "Login to your Rivers Edge Townhomes & Lofts resident portal in Provo, UT! Manage rent, request maintenance, and enhance your living experience with ease.",
  "property_seo_title_referafriend": "Refer A Friend | Rivers Edge Townhomes & Lofts",
  "property_seo_description_referafriend": "Refer a friend to Rivers Edge Townhomes & Lofts in Provo, UT, and foster a vibrant community. Great friends make great neighbors—share the joy today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Rivers Edge Townhomes & Lofts",
  "property_seo_description_scheduletour": "Experience the charm of Rivers Edge Townhomes & Lofts in Provo, UT. See your future home—schedule a tour today and feel the unique vibe!",
  "property_seo_title_privacy": "Privacy Policy | Rivers Edge Townhomes & Lofts",
  "property_seo_description_privacy": "At Rivers Edge Townhomes & Lofts in Provo, UT, we prioritize your privacy. Learn how we protect your information and enhance your living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Rivers Edge Townhomes & Lofts",
  "property_seo_description_accessibility": "At Rivers Edge Townhomes & Lofts in Provo, UT, we prioritize digital inclusion and accessibility. Explore a community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Rivers Edge Townhomes & Lofts",
  "property_seo_description_sitemap": "Navigate through Rivers Edge Townhomes & Lofts’ sitemap to easily find your ideal home in Provo, UT. Your perfect living space awaits—start exploring!",
  "property_seo_title_thankyou": "Thank You | Rivers Edge Townhomes & Lofts",
  "property_seo_description_thankyou": "Thank you for reaching out to Rivers Edge Townhomes & Lofts in Provo! A team member will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Provo, UT | Rivers Edge",
  "property_seo_description_pets": "Rivers Edge Townhomes & Lofts in Provo, UT is pet-friendly. Dogs and cats welcome, up to 2 pets per home, 55 lb max. Review the full pet policy and fees.",
  "property_updated_at": "1793744445465",
  "amenities": [
    {
      "id": "custom_3cc280f3-bc3e-40d6-95ca-5be1c173c438",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-Style Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6aec045b-408e-4e61-b80e-67cb802a812a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Year-Round Hot Tubs & Jacuzzis",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95d512d1-b907-4653-b5a2-cb17a1149344",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "State-of-the-Art Fitness Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7d8561a-145d-470c-8ff1-216980151fef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Dedicated Yoga & Spin Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_341374bb-6e75-499a-88c2-3619f728697e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Private Pickleball Courts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a06f920-312b-4fe3-b222-d5809e5d4963",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Clubhouse & Resident Lounge Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_036d3ebd-be79-4c5b-8d1f-a44f06ffb3a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Entertainment & Game Room with Pool, Ping Pong & Foosball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2056addf-8379-4edd-a8cf-b151b3fac9c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Prime Provo River Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b7ac3ae-90f8-4a38-b3cc-ca9509e1d405",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Stunning Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24c4966b-ad6e-4b94-a89d-9e1171f7f128",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Access to Shopping, Dining & Outdoor Recreation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39465b0d-ea0b-423f-ab53-155fa158d6c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ffc9c9f-16e4-4ec7-b5eb-d47019386702",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77dd5fe6-3e52-4c61-b03f-ac8050460efe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Attached & Detached Garage Options",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfe0da59-8116-49a9-96ae-a3a11559b1bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "High-End Appliance Packages",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1838247a-4b13-436b-8ea4-c0328a948dd9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03cf517b-3147-4f2f-8683-be072b42bfb6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31096021-7572-4ae9-a2d3-cfd5f749a230",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Luxury Interior Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b20e290-4669-4dcb-bd7c-93ccad5c6bf1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Open-Concept Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_704e41b7-1266-4f71-a75a-331fcc4b9eee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Scenic Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_072840ac-07c5-44e5-80aa-2328318d2e1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "external_id": "false",
      "title": "Select Townhomes with No Neighbors Above or Below",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6db4c2f6-3913-4344-a0b9-601117a7f313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-5648-71fe-a331-3b43ca1c6853.webp",
      "image_media": {
        "alt_text": "Modern community kitchen area with island seating and stainless steel appliances.",
        "public_id": "01a18980-5648-71fe-a331-3b43ca1c6853",
        "storage_key": "property/6767906449167908/01a18980-5648-71fe-a331-3b43ca1c6853.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a fully equipped community kitchen, perfect for entertaining guests or casual get-togethers. Features modern appliances and ample counter space.",
      "link": "",
      "alt_text": "Modern community kitchen area with island seating and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15dc9008-e994-4306-b13c-66cfeadca47a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-b0d5-760c-bd52-07a8aa734c94.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating, a fireplace, and large windows.",
        "public_id": "01a18981-b0d5-760c-bd52-07a8aa734c94",
        "storage_key": "property/6767906449167908/01a18981-b0d5-760c-bd52-07a8aa734c94.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a contemporary fireplace, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Modern lounge area with plush seating, a fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_980236ad-35b9-4082-b5d7-387ea7b8007b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-61b1-7539-8bdd-1a0a70f946cb.webp",
      "image_media": {
        "alt_text": "Vinyl record collection displayed on shelves above a pool table in a community lounge.",
        "public_id": "01a18980-61b1-7539-8bdd-1a0a70f946cb",
        "storage_key": "property/6767906449167908/01a18980-61b1-7539-8bdd-1a0a70f946cb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcase your style in our community lounge, featuring a vinyl record collection and a billiards table for resident enjoyment.",
      "link": "",
      "alt_text": "Vinyl record collection displayed on shelves above a pool table in a community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a722d2d-51bb-4eb5-b65c-14027d45bf76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-509e-70ac-a765-64a343d4c834.webp",
      "image_media": {
        "alt_text": "Row of cardio machines including treadmills, ellipticals, and stationary bikes in a fitness center.",
        "public_id": "01a18980-509e-70ac-a765-64a343d4c834",
        "storage_key": "property/6767906449167908/01a18980-509e-70ac-a765-64a343d4c834.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and stationary bikes to help you reach your wellness goals.",
      "link": "",
      "alt_text": "Row of cardio machines including treadmills, ellipticals, and stationary bikes in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec9b248e-849b-4ed4-bd92-d01c85b6a364",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-a63f-7699-8738-e5a20a90db3d.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, kettlebells, medicine balls, and cardio machines.",
        "public_id": "01a18981-a63f-7699-8738-e5a20a90db3d",
        "storage_key": "property/6767906449167908/01a18981-a63f-7699-8738-e5a20a90db3d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Gym with weight racks, kettlebells, medicine balls, and cardio machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd414a6a-141a-4416-97da-2d354ec221b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-24ae-775b-9d54-de8f4cb4aa31.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, free weights, and cable cross machine.",
        "public_id": "01a18981-24ae-775b-9d54-de8f4cb4aa31",
        "storage_key": "property/6767906449167908/01a18981-24ae-775b-9d54-de8f4cb4aa31.webp",
        "width": 3072,
        "height": 1724
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, a full range of free weights, and a versatile cable cross machine for a complete workout.",
      "link": "",
      "alt_text": "Gym with cardio machines, free weights, and cable cross machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_faff3ad7-b130-4e7b-a95a-c2892269e410",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-edc2-7772-92fa-8de80c68bb53.webp",
      "image_media": {
        "alt_text": "Bubbling hot tub with a swimming pool and apartment buildings in the background.",
        "public_id": "01a18980-edc2-7772-92fa-8de80c68bb53",
        "storage_key": "property/6767906449167908/01a18980-edc2-7772-92fa-8de80c68bb53.webp",
        "width": 3072,
        "height": 1638
      },
      "title": "Community",
      "description": "Relax and unwind in our community's luxurious hot tub, adjacent to a sparkling swimming pool, surrounded by modern apartment buildings.",
      "link": "",
      "alt_text": "Bubbling hot tub with a swimming pool and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d89bd95-c7ba-4e2b-af01-bcacee0c059d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Relax and unwind in the resort-style spa and pool area. Enjoy outdoor seating on the elevated balcony, perfect for soaking up the sun or enjoying a cool evening.",
      "link": "",
      "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc5462ea-8805-4fcb-8cb6-0a84c9b3cb40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-bf54-776e-9abd-12025e4905bf.webp",
      "image_media": {
        "alt_text": "Outdoor pickleball courts and swimming pool with mountain views.",
        "public_id": "01a18981-bf54-776e-9abd-12025e4905bf",
        "storage_key": "property/6767906449167908/01a18981-bf54-776e-9abd-12025e4905bf.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Enjoy our vibrant community amenities, including well-maintained pickleball courts, a sparkling swimming pool, and shaded cabanas, all set against a backdrop of stunning mountain scenery.",
      "link": "",
      "alt_text": "Outdoor pickleball courts and swimming pool with mountain views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f3e3d25-0b68-414c-b880-b9da276a3206",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-9f0b-7042-bc81-7ca8891d1c65.webp",
      "image_media": {
        "alt_text": "Artificial turf dog park with fencing and parking lot with covered parking spaces.",
        "public_id": "01a18981-9f0b-7042-bc81-7ca8891d1c65",
        "storage_key": "property/6767906449167908/01a18981-9f0b-7042-bc81-7ca8891d1c65.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Enjoy our convenient on-site amenities, including a dedicated dog park and covered parking for residents.",
      "link": "",
      "alt_text": "Artificial turf dog park with fencing and parking lot with covered parking spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35f62ce1-1956-4526-9e61-6e76852b57f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-69f6-7132-8cd3-a354ca7a72cb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, island, and bar stools.",
        "public_id": "01a18981-69f6-7132-8cd3-a354ca7a72cb",
        "storage_key": "property/6767906449167908/01a18981-69f6-7132-8cd3-a354ca7a72cb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish and modern kitchen featuring dark cabinetry, a white quartz island with bar stools, and sleek stainless steel appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, island, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f313a933-5841-498c-b7a8-25d815e7a977",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-671a-72c9-823b-da1691215665.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a18981-671a-72c9-823b-da1691215665",
        "storage_key": "property/6767906449167908/01a18981-671a-72c9-823b-da1691215665.webp",
        "width": 2048,
        "height": 972
      },
      "title": "Apartment",
      "description": "Discover a chef's dream in this modern kitchen, featuring sleek black cabinetry, high-end stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with black cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f57b7f5-cfb2-4d12-bb77-821802999ca4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-b931-75cf-9fa9-e1ad5c6399cf.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, open to a modern kitchen with stainless steel appliances.",
        "public_id": "01a18981-b931-75cf-9fa9-e1ad5c6399cf",
        "storage_key": "property/6767906449167908/01a18981-b931-75cf-9fa9-e1ad5c6399cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a meal in the stylish dining area, adjacent to a fully equipped kitchen featuring modern stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Dining area with a table and chairs, open to a modern kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1baa9bae-8713-4fdb-a7cd-c4bae67139b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-bc91-754d-abc9-91c5ee535d67.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, leather armchair, and large abstract painting.",
        "public_id": "01a18981-bc91-754d-abc9-91c5ee535d67",
        "storage_key": "property/6767906449167908/01a18981-bc91-754d-abc9-91c5ee535d67.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living space, featuring comfortable seating and contemporary decor. Perfect for entertaining or enjoying a quiet evening.",
      "link": "",
      "alt_text": "Modern living room with a white sofa, leather armchair, and large abstract painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8aae4cf0-9390-45a2-a763-e317b9817d27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-23c9-75c2-9dd0-eee9fd6f417e.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a large bed with plush pillows and a quilted comforter, a comfortable armchair, and two windows with blinds.",
        "public_id": "01a18981-23c9-75c2-9dd0-eee9fd6f417e",
        "storage_key": "property/6767906449167908/01a18981-23c9-75c2-9dd0-eee9fd6f417e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed bedroom. Featuring a spacious king-size bed, comfortable seating, and plenty of natural light, this room is perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a large bed with plush pillows and a quilted comforter, a comfortable armchair, and two windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_427545fa-ce32-4d53-bd2d-c775ee2fbcca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-a4fc-7189-838a-2fba8508410a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood cabinetry.",
        "public_id": "01a18980-a4fc-7189-838a-2fba8508410a",
        "storage_key": "property/6767906449167908/01a18980-a4fc-7189-838a-2fba8508410a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this sleek, modern kitchen featuring white cabinetry, stainless steel appliances, and warm wood accents.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7137d821-0ab7-44b6-9132-4c63752bed0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-3a8a-7619-9f3e-dc09434ee08d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "01a18981-3a8a-7619-9f3e-dc09434ee08d",
        "storage_key": "property/6767906449167908/01a18981-3a8a-7619-9f3e-dc09434ee08d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring sleek white cabinetry, stainless steel appliances, and a large island perfect for casual dining or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_014a85ce-e452-4c9f-87ad-4033a16130ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-03d2-706d-9c24-9e2abca0261a.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment living room and dining area with a blue sofa, coffee table, and dining table.",
        "public_id": "01a18981-03d2-706d-9c24-9e2abca0261a",
        "storage_key": "property/6767906449167908/01a18981-03d2-706d-9c24-9e2abca0261a.webp",
        "width": 3072,
        "height": 1897
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable blue sofa, contemporary coffee table, and a charming dining set, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Interior of a modern apartment living room and dining area with a blue sofa, coffee table, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d20f594-9ad5-45cd-a09b-309ec2615eda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18980-b76a-7169-9379-1ef25826c3f1.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "01a18980-b76a-7169-9379-1ef25826c3f1",
        "storage_key": "property/6767906449167908/01a18980-b76a-7169-9379-1ef25826c3f1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with crisp white linens, accented with coral and floral pillows. A plush pink throw adds a touch of luxury. The room includes a dark wood nightstand with decorative frames and a bedside lamp, all set against a backdrop of clean white walls and plush grey carpeting.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93967788-5742-4403-bdf7-1e5393f9450b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-33ba-739e-b6b7-61fa9b3e7acc.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dual sinks, wood-look cabinets, and minimalist decor.",
        "public_id": "01a18981-33ba-739e-b6b7-61fa9b3e7acc",
        "storage_key": "property/6767906449167908/01a18981-33ba-739e-b6b7-61fa9b3e7acc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring a spacious vanity with dual sinks, sleek wood-look cabinetry, and elegant fixtures. Perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom vanity with dual sinks, wood-look cabinets, and minimalist decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d2829e0-ff4f-4ca2-9acb-b95b7edb0e9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-7125-70b4-9d9c-6ebccbbd5114.webp",
      "image_media": {
        "alt_text": "Washer and dryer with walk-in pantry",
        "public_id": "01a18981-7125-70b4-9d9c-6ebccbbd5114",
        "storage_key": "property/6767906449167908/01a18981-7125-70b4-9d9c-6ebccbbd5114.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit laundry with spacious walk-in pantry and storage shelves.",
      "link": "",
      "alt_text": "Washer and dryer with walk-in pantry",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ba08e6c-156f-47b0-b665-e0b019ff204e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a18981-5c44-7588-b9b6-91588914ca32.webp",
      "image_media": {
        "alt_text": "Exterior view of multifamily buildings with private patios and walkways.",
        "public_id": "01a18981-5c44-7588-b9b6-91588914ca32",
        "storage_key": "property/6767906449167908/01a18981-5c44-7588-b9b6-91588914ca32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A view of the exterior of a multifamily property, showcasing individual unit entrances with private patios and walkways.",
      "link": "",
      "alt_text": "Exterior view of multifamily buildings with private patios and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_95845f79-401b-4be0-bf9b-603b651e9053",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Rodizio Grill Brazilian Steakhouse Provo",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "Outpost of a Brazilian steakhouse chain offering skewered meats carved tableside, plus a salad bar.",
      "poi_long_description": "Outpost of a Brazilian steakhouse chain offering skewered meats carved tableside, plus a salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-47cd-75ab-afc4-c2e7431204de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-47cd-75ab-afc4-c2e7431204de",
        "storage_key": "property/6767906449167908/01a17e48-47cd-75ab-afc4-c2e7431204de.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://www.rodiziogrill.com/provo-riverwoods/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1660826833389874075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rodizio-grill-brazilian-steakhouse-provo",
      "poi_latitude": "40.298773399999995",
      "poi_longitude": "-111.6577191",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-374-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfVqLgyQTYcRm-ujnTRxDBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_a9c5f2f0-eed3-4e92-bd06-50c76883724e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Slackwater",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave #370, Provo, UT 84604, USA",
      "poi_short_description": "Popular pizza restaurant with an extensive beer selection and scenic outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-4cef-75ed-9072-9329c02a23ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-4cef-75ed-9072-9329c02a23ca",
        "storage_key": "property/6767906449167908/01a17e48-4cef-75ed-9072-9329c02a23ca.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.slackwaterpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14969831321735177749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slackwater",
      "poi_latitude": "40.2987536",
      "poi_longitude": "-111.6581233",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-738-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu76ZWgCRTYcRFaaKB0aGv88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6be9e890-dbab-48ea-82c0-cd6e03f0bd0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "La Jolla Groves",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave #610, Provo, UT 84604, USA",
      "poi_short_description": "Serene eatery with European atmosphere & a lemon-tree theme, offering a globally influenced menu.",
      "poi_long_description": "Serene eatery with European atmosphere & a lemon-tree theme, offering a globally influenced menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-cadf-774d-ae93-348572dec862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-cadf-774d-ae93-348572dec862",
        "storage_key": "property/6767906449167908/01a19d93-cadf-774d-ae93-348572dec862.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lajollagroves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16609285433891605382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-jolla-groves",
      "poi_latitude": "40.2992077",
      "poi_longitude": "-111.6580963",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-224-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-2jJwyQTYcRhsstNBoJgOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f56c2ae2-df42-452f-a029-3e01bf5034d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Kneaders Bakery & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4833 N Edgewood Dr #200, Provo, UT 84604, USA",
      "poi_short_description": "Cafe chain specializing in a variety of breads plus sandwiches, salads, pastries & breakfast fare.",
      "poi_long_description": "Cafe chain specializing in a variety of breads plus sandwiches, salads, pastries & breakfast fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-c95f-776d-a6a6-53edc3e94748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-c95f-776d-a6a6-53edc3e94748",
        "storage_key": "property/6767906449167908/01a19d93-c95f-776d-a6a6-53edc3e94748.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kneaders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7261847091423491638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kneaders-bakery--cafe",
      "poi_latitude": "40.297921599999995",
      "poi_longitude": "-111.6611288",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-224-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ac9-76a3-a3cc-fceef0a1bcd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ac9-76a3-a3cc-fceef0a1bcd7",
        "storage_key": "property/6767906449167908/01a17e48-9ac9-76a3-a3cc-fceef0a1bcd7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJyWju7wuQTYcRNjaAaXRDx2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_ca9b26a6-0fa5-4508-9457-a048eca0f6b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "The Bagel Den",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "Locally owned bagel shop serving NY-style bagels and breakfast sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-c6fd-74ed-b6ae-a8f534789615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-c6fd-74ed-b6ae-a8f534789615",
        "storage_key": "property/6767906449167908/01a19d93-c6fd-74ed-b6ae-a8f534789615.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thebagelden.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=193473589004586133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bagel-den",
      "poi_latitude": "40.2983997",
      "poi_longitude": "-111.6577549",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-691-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJde3uDHeRTYcRlcwJQjRbrwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_9a6ddd11-f88e-4008-8066-54617f67aec0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Malawi's Pizza Provo Riverwoods",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave #110, Provo, UT 84604, USA",
      "poi_short_description": "Woodsy-chic counter-serve pizza parlor where portions of the proceeds go to African children.",
      "poi_long_description": "Woodsy-chic counter-serve pizza parlor where portions of the proceeds go to African children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-cce1-76df-839d-8d39d6aae170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-cce1-76df-839d-8d39d6aae170",
        "storage_key": "property/6767906449167908/01a19d93-cce1-76df-839d-8d39d6aae170.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.malawispizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14482058949721288331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malawis-pizza-provo-riverwoods",
      "poi_latitude": "40.2990216",
      "poi_longitude": "-111.6596257",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-225-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-DOLwyQTYcRi25nsuKb-sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_177cce8e-a498-4c18-ad14-96fe875d35b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "The Happy Sumo",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "Sophisticated Asian bistro offering both traditional Japanese fare & innovative sushi rolls.",
      "poi_long_description": "Sophisticated Asian bistro offering both traditional Japanese fare & innovative sushi rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-47a7-7007-819a-38d8a4cb0a9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-47a7-7007-819a-38d8a4cb0a9c",
        "storage_key": "property/6767906449167908/01a17e48-47a7-7007-819a-38d8a4cb0a9c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://happysumosushi.com/provo?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11661353971150099739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-happy-sumo",
      "poi_latitude": "40.299059199999995",
      "poi_longitude": "-111.6575356",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-225-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-DOLwyQTYcRGxV--qZz1aE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_efad8180-c56b-4966-b96a-047e0927e58c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Shoots Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4801 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "Cozy, relaxed eatery in a shopping center offering Chinese bites, plus lunch specials & kids' meals.",
      "poi_long_description": "Cozy, relaxed eatery in a shopping center offering Chinese bites, plus lunch specials & kids' meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-4a6b-707b-b4d3-e745055da2fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-4a6b-707b-b4d3-e745055da2fb",
        "storage_key": "property/6767906449167908/01a17e48-4a6b-707b-b4d3-e745055da2fb.webp",
        "width": 1125,
        "height": 809
      },
      "poi_business_url": "https://shootschinese.pages.dev/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1166366024776502116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoots-chinese-restaurant",
      "poi_latitude": "40.2991268",
      "poi_longitude": "-111.6576182",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-225-0445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-DOLwyQTYcRZEvjSLjDLxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_48323d08-b84a-4ae9-a02e-f711ae94cce1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Black Sheep Cafe",
      "poi_type": "Restaurants",
      "poi_address": "19 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Contemporary Southwestern Native American cooking served with a full bar in an upscale-casual space.",
      "poi_long_description": "Contemporary Southwestern Native American cooking served with a full bar in an upscale-casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-c599-729a-9e06-f7a85ddb4b8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-c599-729a-9e06-f7a85ddb4b8b",
        "storage_key": "property/6767906449167908/01a19d93-c599-729a-9e06-f7a85ddb4b8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blacksheepcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13491545579687418964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-sheep-cafe",
      "poi_latitude": "40.2342829",
      "poi_longitude": "-111.6590597",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-607-2485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50M6bVOXTYcRVJxCNDmZO7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_410f097c-fd5a-45d4-bc99-d04e5648274b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Communal",
      "poi_type": "Restaurants",
      "poi_address": "102 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Locally sourced seasonal American menus star at this comfy kitchen with shared farm-table seating.",
      "poi_long_description": "Locally sourced seasonal American menus star at this comfy kitchen with shared farm-table seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-c6fb-76e4-ab0b-9b4624e25283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-c6fb-76e4-ab0b-9b4624e25283",
        "storage_key": "property/6767906449167908/01a19d93-c6fb-76e4-ab0b-9b4624e25283.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.communalrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8530779246421279842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "communal",
      "poi_latitude": "40.2352417",
      "poi_longitude": "-111.6583861",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-373-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa39R1OXTYcRYgQ30IZqY3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5c1627c1-6e2b-4106-a9ac-b918f7209526",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Block Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3330 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "An open kitchen turns out refined American plates fueled by seasonal, locally sourced ingredients.",
      "poi_long_description": "An open kitchen turns out refined American plates fueled by seasonal, locally sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-c644-726d-986a-02986bf6d399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-c644-726d-986a-02986bf6d399",
        "storage_key": "property/6767906449167908/01a19d93-c644-726d-986a-02986bf6d399.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.blockrestaurantgroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6685927815026962120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "block-restaurant",
      "poi_latitude": "40.2779107",
      "poi_longitude": "-111.6570362",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-885-7558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb7L-HyQTYcRyO6VmOwvyVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fusion_restaurant"
    },
    {
      "id": "custom_27f3b84b-4e18-4be4-94c7-c9855f11a592",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "India Palace",
      "poi_type": "Restaurants",
      "poi_address": "98 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "Northern Indian specialties & a popular lunch buffet are served amid traditional decor.",
      "poi_long_description": "Northern Indian specialties & a popular lunch buffet are served amid traditional decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-ce6d-765f-a067-fda08a6c3c85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-ce6d-765f-a067-fda08a6c3c85",
        "storage_key": "property/6767906449167908/01a19d93-ce6d-765f-a067-fda08a6c3c85.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://indiapalaceprovo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3427705496109841058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "india-palace",
      "poi_latitude": "40.234082699999995",
      "poi_longitude": "-111.66032",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-373-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93ILnFSXTYcRovpH6vynkS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_8798ef13-829b-4f6b-b22f-07909d6d7978",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Demae Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "82 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "Strip-mall spot for sushi, bento boxes & Japanese standards like teriyaki & tempura.",
      "poi_long_description": "Strip-mall spot for sushi, bento boxes & Japanese standards like teriyaki & tempura.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-4f1c-770f-b9fc-2ad5e062a6da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-4f1c-770f-b9fc-2ad5e062a6da",
        "storage_key": "property/6767906449167908/01a17e48-4f1c-770f-b9fc-2ad5e062a6da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.demaejapanese.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10409414823471515878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "demae-japanese-restaurant",
      "poi_latitude": "40.2339543",
      "poi_longitude": "-111.6601256",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-374-0306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-909f-7672-a1ca-7c659ed3f327",
        "storage_key": "property/6767906449167908/01a17e46-909f-7672-a1ca-7c659ed3f327.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaaibnVSXTYcR5oi0aKGrdZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_fc3d4c4a-4b38-4fee-b666-0673d05cf7ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Rockwell Ice Cream | Local, Super-Premium",
      "poi_type": "Restaurants",
      "poi_address": "43 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Mellow, modern ice cream parlor scooping housemade, old-fashioned ice cream in unique flavors.",
      "poi_long_description": "Mellow, modern ice cream parlor scooping housemade, old-fashioned ice cream in unique flavors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-54fc-76bf-b390-280f3fd2b1c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-54fc-76bf-b390-280f3fd2b1c6",
        "storage_key": "property/6767906449167908/01a17e48-54fc-76bf-b390-280f3fd2b1c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rockwellicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7893231446038759441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwell-ice-cream--local-super-premium",
      "poi_latitude": "40.2343462",
      "poi_longitude": "-111.6589347",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-318-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa8iAaVOXTYcREUgVFy5kim0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_2a7bbf37-9740-4813-9b39-9a1e84b6902a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Ike's Creamery",
      "poi_type": "Restaurants",
      "poi_address": "Provo, UT 84604, USA",
      "poi_short_description": "Themed 1950s-style ice cream shop offering classic ice cream treats and Dole Whip.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d196-73ba-995c-9a2487105276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d196-73ba-995c-9a2487105276",
        "storage_key": "property/6767906449167908/01a19d93-d196-73ba-995c-9a2487105276.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://shopsatriverwoods.com/ikes-creamery/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11220748440902718356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikes-creamery",
      "poi_latitude": "40.299337699999995",
      "poi_longitude": "-111.6594503",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-224-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjcinJQyQTYcRlFMGxkEbuJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_016fe48c-7f27-4185-a4a2-2ef5ecc0dc90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2255 N University Pkwy, Provo, UT 84604, USA",
      "poi_short_description": "Convenient neighborhood grocery store featuring a pharmacy and essential food items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-5d13-74bf-b70e-4051a80e47c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-5d13-74bf-b70e-4051a80e47c8",
        "storage_key": "property/6767906449167908/01a17e46-5d13-74bf-b70e-4051a80e47c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4100-provo-ut/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2812461961080414271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "40.262899",
      "poi_longitude": "-111.669892",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 385-219-3070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a1-768f-a8c1-a9e6424886c6",
        "storage_key": "property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWhY2HmaTYcRPyB_pkDfByc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_88d4e1c6-b6d4-483d-bbfe-a718b130dcf8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2291 N University Pkwy, Provo, UT 84604, USA",
      "poi_short_description": "Convenient gas station and store offering custom-made coffee and quick snacks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d1e9-7461-b9da-fbeeb9a95e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d1e9-7461-b9da-fbeeb9a95e03",
        "storage_key": "property/6767906449167908/01a19d93-d1e9-7461-b9da-fbeeb9a95e03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ut/provo/2291-n-university-pkwy-41191?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8819786212125223878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.264547",
      "poi_longitude": "-111.6705123",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-368-4231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d94-17ec-7609-ad50-7aeb990f66b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a19d94-17ec-7609-ad50-7aeb990f66b0",
        "storage_key": "property/6767906449167908/01a19d94-17ec-7609-ad50-7aeb990f66b0.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ10EK0d-bTYcRxqucqNQsZno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_bf085b64-2e4d-4f36-a4c8-04edd7dc852d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Smith's",
      "poi_type": "Shopping & Retail",
      "poi_address": "350 N Freedom Blvd, Provo, UT 84601, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-5b63-777d-aeca-218a729452e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-5b63-777d-aeca-218a729452e2",
        "storage_key": "property/6767906449167908/01a17e46-5b63-777d-aeca-218a729452e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/ut/provo/350-no-freedom-blvd-provo-ut/706/00136?cid=loc_70600136_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13665563599263190511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiths",
      "poi_latitude": "40.2387559",
      "poi_longitude": "-111.6613349",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-377-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a1-768f-a8c1-a9e6424886c6",
        "storage_key": "property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yW4pKuQTYcR702XtbDVpb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1139fe67-ffa6-40b9-83ff-c5b047fe788c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Macey's Provo",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 N State St, Provo, UT 84601, USA",
      "poi_short_description": "Full-service grocery store featuring a scratch-made bakery and affordable ice cream.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d6c8-7116-bce8-74ac5244d926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d6c8-7116-bce8-74ac5244d926",
        "storage_key": "property/6767906449167908/01a19d93-d6c8-7116-bce8-74ac5244d926.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maceys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17521893081910200939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maceys-provo",
      "poi_latitude": "40.2529921",
      "poi_longitude": "-111.6665579",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-356-3216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a1-768f-a8c1-a9e6424886c6",
        "storage_key": "property/6767906449167908/01a17e46-90a1-768f-a8c1-a9e6424886c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcze8nSaTYcRa8qhS-xEKvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a3846641-101c-4015-87a4-3182b46898ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1273 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-550e-757f-95ea-db19269f5ba6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-550e-757f-95ea-db19269f5ba6",
        "storage_key": "property/6767906449167908/01a17e48-550e-757f-95ea-db19269f5ba6.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/provo-ut-pharmacies/1273-n-university-ave-provo-ut-84604/storeid=10230?WT.mc_id=LS_GOOGLE_RX_10230",
      "poi_directions_map_url": "https://maps.google.com/?cid=9745938557970373426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2512589",
      "poi_longitude": "-111.6591975",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-377-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ae8-76a8-983d-1b6ba9d93e94",
        "storage_key": "property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4w3B6KOQTYcRMlubdnuHQIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_087c498b-ca60-4044-828d-361cfabfa2c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1315 N State St, Provo, UT 84604, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d735-75ad-a04c-9580b1f36e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d735-75ad-a04c-9580b1f36e0a",
        "storage_key": "property/6767906449167908/01a19d93-d735-75ad-a04c-9580b1f36e0a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1315+n+state+st-provo-ut-84604/id=11734",
      "poi_directions_map_url": "https://maps.google.com/?cid=2041590537853200065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.2515885",
      "poi_longitude": "-111.6688864",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-616-5223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRqe4wqaTYcRweaJAccvVRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a0324c87-ea21-49da-b817-2a3785a3550f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "The Shops At Riverwoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "4801 N University Ave, Provo, UT 84604, USA",
      "poi_short_description": "Chic, open-air retail complex offering shopping, dining & entertainment with a mountain backdrop.",
      "poi_long_description": "Chic, open-air retail complex offering shopping, dining & entertainment with a mountain backdrop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-54ac-71b3-a4cf-2e92d49bc36d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-54ac-71b3-a4cf-2e92d49bc36d",
        "storage_key": "property/6767906449167908/01a17e48-54ac-71b3-a4cf-2e92d49bc36d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://shopsatriverwoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7198380765745416920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-riverwoods",
      "poi_latitude": "40.2991326",
      "poi_longitude": "-111.6587712",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 385-475-3143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq5Pjpg6QTYcR2IpC9CrJ5WM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d27f58e7-edf7-4eea-aea6-8333499d6fa6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 Towne Centre Blvd Ste A, Provo, UT 84601, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d92b-70ec-b3b0-527f3d096b48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d92b-70ec-b3b0-527f3d096b48",
        "storage_key": "property/6767906449167908/01a19d93-d92b-70ec-b3b0-527f3d096b48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.target.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12518373707153521368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.2156075",
      "poi_longitude": "-111.6627729",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 385-447-5902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf2ddikKXTYcR2Lp5vI8yuq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0ac32baf-1012-44de-8a0c-d018c8ca3b1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1550 S University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d9c7-7368-9572-c2acf6667b5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d9c7-7368-9572-c2acf6667b5c",
        "storage_key": "property/6767906449167908/01a19d93-d9c7-7368-9572-c2acf6667b5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Provo/UT/Provo/84601/4416?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6527335348034880237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "40.21269100000001",
      "poi_longitude": "-111.6602783",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-418-1014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDRXbNmGXTYcR7UJ4berAlVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c115deed-c8f8-4d02-8d44-3cb5a458f10f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Harbor Freight",
      "poi_type": "Shopping & Retail",
      "poi_address": "977 S University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_long_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-d9dc-7375-92bd-5b84cc200fa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-d9dc-7375-92bd-5b84cc200fa2",
        "storage_key": "property/6767906449167908/01a19d93-d9dc-7375-92bd-5b84cc200fa2.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.harborfreight.com/storelocator/977-s-university-avenue-provo-84601?number=3657",
      "poi_directions_map_url": "https://maps.google.com/?cid=7904065728164633784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbor-freight",
      "poi_latitude": "40.2204856",
      "poi_longitude": "-111.6570823",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 385-585-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA3FvPMaXTYcRuJyX-ObhsG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_0b44a2f1-8e1a-4e32-a57f-940e39d6517d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Canyon Crest Elementary School",
      "poi_type": "Education",
      "poi_address": "4664 N Canyon Rd, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-65da-752e-9f79-489f4742c6ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-65da-752e-9f79-489f4742c6ca",
        "storage_key": "property/6767906449167908/01a17e48-65da-752e-9f79-489f4742c6ca.webp",
        "width": 936,
        "height": 259
      },
      "poi_business_url": "https://canyoncrest.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8453113745656642753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canyon-crest-elementary-school",
      "poi_latitude": "40.2954257",
      "poi_longitude": "-111.6523783",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-221-9873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-eu3bG2QTYcRwfzVRyp-T3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9b20ff60-5b58-409f-b8ae-25acd12eb53f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Centennial Middle School",
      "poi_type": "Education",
      "poi_address": "305 E 2320 N, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-6628-773c-af74-33d44ab103f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-6628-773c-af74-33d44ab103f7",
        "storage_key": "property/6767906449167908/01a17e48-6628-773c-af74-33d44ab103f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centennial.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13295813206274750893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-middle-school",
      "poi_latitude": "40.2650203",
      "poi_longitude": "-111.653424",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-370-4621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfb7SZ5CQTYcRrTn0t6o3hLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4ab40125-68a2-4eb5-9bbf-39ce8dfcaa24",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Rock Canyon Elementary School",
      "poi_type": "Education",
      "poi_address": "435 E 2320 N, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-67da-72de-8e83-e8b91fa84a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-67da-72de-8e83-e8b91fa84a01",
        "storage_key": "property/6767906449167908/01a17e48-67da-72de-8e83-e8b91fa84a01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rockcanyon.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4192090239335895456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-canyon-elementary-school",
      "poi_latitude": "40.2648787",
      "poi_longitude": "-111.6503273",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-374-4935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzQJII5KQTYcRoJH_rdxLLTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5ea6e924-e240-4205-b837-4d17d0ad986b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Timpview High School",
      "poi_type": "Education",
      "poi_address": "3570 Timpview Dr, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-65e6-7458-b122-fae0ff57928d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-65e6-7458-b122-fae0ff57928d",
        "storage_key": "property/6767906449167908/01a17e48-65e6-7458-b122-fae0ff57928d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://timpview.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7044349684428429838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timpview-high-school",
      "poi_latitude": "40.2805599",
      "poi_longitude": "-111.6457285",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-221-9720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ7D1BmGQTYcRDtr9JbeOwmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d6af6481-0786-447a-a620-f5c738ab9896",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo High School",
      "poi_type": "Education",
      "poi_address": "1199 Lakeshore Dr, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-6ada-758f-883a-4f46dd539829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-6ada-758f-883a-4f46dd539829",
        "storage_key": "property/6767906449167908/01a17e48-6ada-758f-883a-4f46dd539829.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://provohigh.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=863469582137260656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-high-school",
      "poi_latitude": "40.250431",
      "poi_longitude": "-111.7154793",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-373-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd6smLqSQTYcRcHqllQKp-ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_254e522a-5323-40ea-8099-7d1abe25fb7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Franklin School",
      "poi_type": "Education",
      "poi_address": "350 S 600 W, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-dcee-71f7-91c6-c8edaed5b6a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-dcee-71f7-91c6-c8edaed5b6a9",
        "storage_key": "property/6767906449167908/01a19d93-dcee-71f7-91c6-c8edaed5b6a9.webp",
        "width": 1000,
        "height": 500
      },
      "poi_business_url": "https://franklin.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11107531614601141912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franklin-school",
      "poi_latitude": "40.229115199999995",
      "poi_longitude": "-111.669987",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-374-4925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt0l6hP6ZTYcRmN64OyfhJZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_988f379c-9d1f-40c4-9470-7c0129a545a2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Wasatch Elementary School",
      "poi_type": "Education",
      "poi_address": "1006 N Locust Ln, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-de1e-716c-9f22-432e8c6638ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-de1e-716c-9f22-432e8c6638ad",
        "storage_key": "property/6767906449167908/01a19d93-de1e-716c-9f22-432e8c6638ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wasatch.provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15971481726483568639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasatch-elementary-school",
      "poi_latitude": "40.2466991",
      "poi_longitude": "-111.6336022",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-374-4910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxYmD8iQTYcR_xeyewIapt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6ed4d431-7961-4eb1-b0cd-a99b697836ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo City School District",
      "poi_type": "Education",
      "poi_address": "280 W 940 N, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9456-749b-b6c3-77946c9c42fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-9456-749b-b6c3-77946c9c42fc",
        "storage_key": "property/6767906449167908/01a17e48-9456-749b-b6c3-77946c9c42fc.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://provo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17596732475405055383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-city-school-district",
      "poi_latitude": "40.2465869",
      "poi_longitude": "-111.6635799",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-374-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6zMr6eQTYcRlzUZdPQmNPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f88cdb72-f92f-4eda-8563-d99833187e98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Brigham Young University",
      "poi_type": "Education",
      "poi_address": "E N Campus Dr, Provo, UT 84602, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d91-6dd5-71d8-9c16-7e10ec1f1c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d91-6dd5-71d8-9c16-7e10ec1f1c0d",
        "storage_key": "property/6767906449167908/01a19d91-6dd5-71d8-9c16-7e10ec1f1c0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.byu.edu/?y_source=1_MjAxNzE5ODIzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13780649426539240524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brigham-young-university",
      "poi_latitude": "40.2518495",
      "poi_longitude": "-111.6493051",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-422-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbagSryQTYcRTNwP86OzPr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eb50a803-20a4-4f8f-b8a2-95d550638eef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Utah Valley University",
      "poi_type": "Education",
      "poi_address": "800 W University Pkwy, Orem, UT 84058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-5c5f-704d-8c69-671035155ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-5c5f-704d-8c69-671035155ee1",
        "storage_key": "property/6767906449167908/01a17e46-5c5f-704d-8c69-671035155ee1.webp",
        "width": 715,
        "height": 433
      },
      "poi_business_url": "http://www.uvu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7156850395324189345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utah-valley-university",
      "poi_latitude": "40.2787541",
      "poi_longitude": "-111.7153714",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-863-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxfW57h6bTYcRoYrpE4Q9UmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b8cc4425-b087-4d1f-bfdd-978de49131d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Velour Live Music Gallery",
      "poi_type": "Entertainment",
      "poi_address": "135 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Intimate live music venue featuring local bands and open mic nights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-6cdb-76d4-8aca-519b2ac6f9f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-6cdb-76d4-8aca-519b2ac6f9f8",
        "storage_key": "property/6767906449167908/01a17e48-6cdb-76d4-8aca-519b2ac6f9f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.velourlive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9538092842765838717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "velour-live-music-gallery",
      "poi_latitude": "40.2355919",
      "poi_longitude": "-111.6589584",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ad1-712f-8fe0-877390a51588.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ad1-712f-8fe0-877390a51588",
        "storage_key": "property/6767906449167908/01a17e48-9ad1-712f-8fe0-877390a51588.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJacpWc1OXTYcRfenAz-ccXoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6acbacf7-fda4-49bd-a617-2728c6b0ee8d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Beach",
      "poi_type": "Entertainment",
      "poi_address": "4801 N University Ave #210, Provo, UT 84604, USA",
      "poi_short_description": "Versatile family amusement center featuring indoor surfing alongside laser tag, bowling, and ropes courses.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-6ebf-72ab-8d19-68c70f8647af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-6ebf-72ab-8d19-68c70f8647af",
        "storage_key": "property/6767906449167908/01a17e48-6ebf-72ab-8d19-68c70f8647af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.provobeach.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13172435716855332857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-beach",
      "poi_latitude": "40.2996056",
      "poi_longitude": "-111.6590822",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-224-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2XkXrw6QTYcR-X_UcX7kzbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_76277ac8-130f-4aa5-9f6c-51a96184d2ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Brigham Young University Museum of Art (MOA)",
      "poi_type": "Entertainment",
      "poi_address": "500 Campus Dr, Provo, UT 84602, USA",
      "poi_short_description": "Featuring a wide range of art (from religious to contemporary) in 10 galleries & a sculpture garden.",
      "poi_long_description": "Featuring a wide range of art (from religious to contemporary) in 10 galleries & a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-6ba1-7382-9e39-2d303a449297.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-6ba1-7382-9e39-2d303a449297",
        "storage_key": "property/6767906449167908/01a17e46-6ba1-7382-9e39-2d303a449297.webp",
        "width": 1280,
        "height": 1218
      },
      "poi_business_url": "http://moa.byu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2623052657080059257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brigham-young-university-museum-of-art-moa",
      "poi_latitude": "40.2507587",
      "poi_longitude": "-111.6479756",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-422-8287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a0-7568-b46d-fecb28cb3fcc",
        "storage_key": "property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJV39RE7uQTYcRecVmfH70ZiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_8dd76cac-e997-4bb2-b4b6-0e2136eabdf5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Bean Life Science Museum",
      "poi_type": "Entertainment",
      "poi_address": "645 E Phillips Ln, Provo, UT 84604, USA",
      "poi_short_description": "Natural history museum at Brigham Young University, with animal dioramas & environmental education.",
      "poi_long_description": "Natural history museum at Brigham Young University, with animal dioramas & environmental education.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-6cbb-7618-94e5-04c2352d5001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-6cbb-7618-94e5-04c2352d5001",
        "storage_key": "property/6767906449167908/01a17e46-6cbb-7618-94e5-04c2352d5001.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://lsm.byu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9136850845034034750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bean-life-science-museum",
      "poi_latitude": "40.2533777",
      "poi_longitude": "-111.647436",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-422-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a0-7568-b46d-fecb28cb3fcc",
        "storage_key": "property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYf9r76QTYcRPjb7N2-dzH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a3dbd7b1-aff6-41fa-83e0-74b51c63f7ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Covey Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "425 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "Performance facility with an auditorium, experimental theater space, art galleries & dance studios.",
      "poi_long_description": "Performance facility with an auditorium, experimental theater space, art galleries & dance studios.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-6aea-7709-b29e-627a0f6946e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-6aea-7709-b29e-627a0f6946e8",
        "storage_key": "property/6767906449167908/01a17e48-6aea-7709-b29e-627a0f6946e8.webp",
        "width": 931,
        "height": 396
      },
      "poi_business_url": "https://www.provo.gov/185/Covey-Center-for-the-Arts",
      "poi_directions_map_url": "https://maps.google.com/?cid=11095493631632600270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covey-center-for-the-arts",
      "poi_latitude": "40.233517",
      "poi_longitude": "-111.66601",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-852-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ad1-712f-8fe0-877390a51588.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ad1-712f-8fe0-877390a51588",
        "storage_key": "property/6767906449167908/01a17e48-9ad1-712f-8fe0-877390a51588.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR7NP4_-ZTYcRzuwR6asc-5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ed058c4e-3230-44ec-b2e8-6a73412e7abd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Cinemark Provo 16",
      "poi_type": "Entertainment",
      "poi_address": "1200 Towne Centre Blvd Ste 2050, Provo, UT 84601, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e1f1-738a-bb67-872a1194eda3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e1f1-738a-bb67-872a1194eda3",
        "storage_key": "property/6767906449167908/01a19d93-e1f1-738a-bb67-872a1194eda3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ut-provo/cinemark-provo-16?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMxNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11231590477110330254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-provo-16",
      "poi_latitude": "40.2172851",
      "poi_longitude": "-111.6637302",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-852-8526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ad2-75a9-9c8f-e8f1fbae3d20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ad2-75a9-9c8f-e8f1fbae3d20",
        "storage_key": "property/6767906449167908/01a17e48-9ad2-75a9-9c8f-e8f1fbae3d20.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJMyQScF6XTYcRjkPSCgig3ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_1591d3f9-60dd-4e45-877a-98c28f40fccc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Getout Games",
      "poi_type": "Entertainment",
      "poi_address": "283 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "Escape-room venue with a choice of zombie, mafia, nuclear reactor & Egyptian themed challenges.",
      "poi_long_description": "Escape-room venue with a choice of zombie, mafia, nuclear reactor & Egyptian themed challenges.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e518-71c9-84b2-8a00cf042822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e518-71c9-84b2-8a00cf042822",
        "storage_key": "property/6767906449167908/01a19d93-e518-71c9-84b2-8a00cf042822.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://getoutgames.com/provo/?utm_source=google&utm_medium=GMB&utm_campaign=provo",
      "poi_directions_map_url": "https://maps.google.com/?cid=18023046500222940773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "getout-games",
      "poi_latitude": "40.237424999999995",
      "poi_longitude": "-111.659092",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-310-4434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlf4gkqyQTYcRZbYiQE25Hvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_ab3bec0c-accb-439a-a277-b5803654328c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Daughters of Utah Pioneers Museum",
      "poi_type": "Entertainment",
      "poi_address": "550 N 500 W, Provo, UT 84601, USA",
      "poi_short_description": "Small local history museum displaying artifacts including rifles & tools, plus old photographs.",
      "poi_long_description": "Small local history museum displaying artifacts including rifles & tools, plus old photographs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e1a4-702b-a951-a36ff3b19856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e1a4-702b-a951-a36ff3b19856",
        "storage_key": "property/6767906449167908/01a19d93-e1a4-702b-a951-a36ff3b19856.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.provo.gov/966/Pioneer-Museum-and-Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=281633635733600287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-daughters-of-utah-pioneers-museum",
      "poi_latitude": "40.2414444",
      "poi_longitude": "-111.6667472",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-852-6609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a0-7568-b46d-fecb28cb3fcc",
        "storage_key": "property/6767906449167908/01a17e46-90a0-7568-b46d-fecb28cb3fcc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWP-dAeaTYcRH_izrkyQ6AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1dec6fdb-4d3e-409b-ad64-a4cf7583e24a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "3hive Record Lounge",
      "poi_type": "Shopping & Retail",
      "poi_address": "71 E Center St, Provo, UT 84606, USA",
      "poi_short_description": "Locally owned record shop featuring a curated selection of new and used vinyl.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e1a1-72cc-8e72-d8b1b679d9da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e1a1-72cc-8e72-d8b1b679d9da",
        "storage_key": "property/6767906449167908/01a19d93-e1a1-72cc-8e72-d8b1b679d9da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://shop.3hive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18011972893423789167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3hive-record-lounge",
      "poi_latitude": "40.2340215",
      "poi_longitude": "-111.6573443",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-900-3116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa3WXIuCRTYcRb2R9QOph9_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_8c19598d-a388-435a-a71b-6dc42e22d46a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo City Library at Academy Square",
      "poi_type": "Education",
      "poi_address": "550 N University Ave, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-638d-733c-b933-b301f158a552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-638d-733c-b933-b301f158a552",
        "storage_key": "property/6767906449167908/01a17e46-638d-733c-b933-b301f158a552.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://provolibrary.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=323493429651554190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-city-library-at-academy-square",
      "poi_latitude": "40.2410501",
      "poi_longitude": "-111.65752390000002",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-852-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90a6-726b-a95b-f0696a97e9f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90a6-726b-a95b-f0696a97e9f4",
        "storage_key": "property/6767906449167908/01a17e46-90a6-726b-a95b-f0696a97e9f4.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ50Jqg66QTYcRjr-NcY9HfQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_fc37a6cc-7ccc-41f5-946d-dec5c8a7ca1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Intermountain Health Utah Valley Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1034 N 500 W, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-7562-74cd-8c4f-4a96aaa2797f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-7562-74cd-8c4f-4a96aaa2797f",
        "storage_key": "property/6767906449167908/01a17e46-7562-74cd-8c4f-4a96aaa2797f.webp",
        "width": 1280,
        "height": 707
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/utah-valley-hospital?utm_source=yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570516454234853880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-health-utah-valley-hospital",
      "poi_latitude": "40.2474852",
      "poi_longitude": "-111.6656187",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-357-7850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90bb-75fb-82cf-42f60e82dafb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90bb-75fb-82cf-42f60e82dafb",
        "storage_key": "property/6767906449167908/01a17e46-90bb-75fb-82cf-42f60e82dafb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ986XXqeQTYcR-BGHLecpL1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_1e513ee1-760d-45e6-8c5d-9e79836e8411",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Intermountain Health Utah Valley Clinic - InstaCare",
      "poi_type": "Health and Wellness",
      "poi_address": "395 West Cougar Blvd Floor 2, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e779-75fb-91ab-1c69fb94661b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e779-75fb-91ab-1c69fb94661b",
        "storage_key": "property/6767906449167908/01a19d93-e779-75fb-91ab-1c69fb94661b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.intermountainhealth.org/locations/utah-valley-clinic/instacare?utm_source=yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14965924481219727248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-health-utah-valley-clinic---instacare",
      "poi_latitude": "40.24901",
      "poi_longitude": "-111.6653595",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-357-1770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSIvU6iRTYcRkI9s1gWlsc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f141fc64-813e-4638-b1e1-9a365c42ece2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Riverwoods Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "280 W River Park Dr #120, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-7370-72af-8c80-7180d49f1a95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-7370-72af-8c80-7180d49f1a95",
        "storage_key": "property/6767906449167908/01a17e48-7370-72af-8c80-7180d49f1a95.webp",
        "width": 853,
        "height": 480
      },
      "poi_business_url": "http://riverwoodsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8118953162052207777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverwoods-urgent-care",
      "poi_latitude": "40.3043941",
      "poi_longitude": "-111.6620303",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-229-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-90bb-75fb-82cf-42f60e82dafb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-90bb-75fb-82cf-42f60e82dafb",
        "storage_key": "property/6767906449167908/01a17e46-90bb-75fb-82cf-42f60e82dafb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwVq6OwaQTYcRoQQohOJQrHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_869dfaa5-c88d-4527-bd00-8f72bca00dba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Revere Health Provo Family Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "1055 N 500 W Bldg A, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-732b-7777-b9ff-a68c6e3e5891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-732b-7777-b9ff-a68c6e3e5891",
        "storage_key": "property/6767906449167908/01a17e48-732b-7777-b9ff-a68c6e3e5891.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://reverehealth.com/departments/provo-family-medicine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16301724954350636137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revere-health-provo-family-medicine",
      "poi_latitude": "40.2487607",
      "poi_longitude": "-111.6680448",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-812-5033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YXzMMqbTYcRacwwynlcO-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_7559aed2-b148-4104-b8b7-f90177af1958",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1315 N State St, Provo, UT 84604, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-7765-72c5-aed7-18a9021523fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-7765-72c5-aed7-18a9021523fe",
        "storage_key": "property/6767906449167908/01a17e48-7765-72c5-aed7-18a9021523fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1315+n+state+st-provo-ut-84604/id=11734",
      "poi_directions_map_url": "https://maps.google.com/?cid=14991545415295725307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.2516008",
      "poi_longitude": "-111.6688652",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-616-5223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ae8-76a8-983d-1b6ba9d93e94",
        "storage_key": "property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-F9S2KbTYcR-27WaCCrDNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_50c0cdf2-d8f5-49ec-9de3-9173a793efd1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Smith's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "350 N Freedom Blvd, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e6c1-750e-8350-ef0553b3762e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e6c1-750e-8350-ef0553b3762e",
        "storage_key": "property/6767906449167908/01a19d93-e6c1-750e-8350-ef0553b3762e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/rx/pharmacy/details/706/00136?cid=loc_70600136P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15129023273503252700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiths-pharmacy",
      "poi_latitude": "40.2387154",
      "poi_longitude": "-111.6613457",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-377-9250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9ae8-76a8-983d-1b6ba9d93e94",
        "storage_key": "property/6767906449167908/01a17e48-9ae8-76a8-983d-1b6ba9d93e94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yW4pKuQTYcR3GDHn4IW9dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c4e217c1-e48f-4bfe-b20a-eb244d22911d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "3B Movement",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 N University Ave #530, Provo, UT 84604, USA",
      "poi_short_description": "Welcoming Ashtanga-based yoga studio offering diverse classes and teacher training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-7f33-7748-bd25-a570325b6311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-7f33-7748-bd25-a570325b6311",
        "storage_key": "property/6767906449167908/01a17e48-7f33-7748-bd25-a570325b6311.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.3bmovement.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12785109348662166330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3b-movement",
      "poi_latitude": "40.298406199999995",
      "poi_longitude": "-111.6582336",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-434-7541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9070-7186-a4fb-375027767d59",
        "storage_key": "property/6767906449167908/01a17e46-9070-7186-a4fb-375027767d59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK-DOLwyQTYcROsOI1TbVbbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_f8b2509c-33b6-46f3-9bd3-64e9b5e6c0b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Resistance Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 N University Ave #145, Provo, UT 84604, USA",
      "poi_short_description": "Welcoming pilates studio offering challenging, full-body reformer workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-e709-7742-8a05-3b49b5b5647f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-e709-7742-8a05-3b49b5b5647f",
        "storage_key": "property/6767906449167908/01a19d93-e709-7742-8a05-3b49b5b5647f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://resistance-pilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4456726499828956223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "resistance-pilates",
      "poi_latitude": "40.298803",
      "poi_longitude": "-111.6592351",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 385-462-0372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34d1rvuRTYcRP_xfiyN52T0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c0545f79-29c1-49f3-92d4-886da31c6c02",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "320 500 N, Provo, UT 84601, USA",
      "poi_short_description": "Multi-use community recreation center featuring indoor and outdoor aquatic areas and fitness facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-7d9c-702b-8716-717f42865be1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-7d9c-702b-8716-717f42865be1",
        "storage_key": "property/6767906449167908/01a17e48-7d9c-702b-8716-717f42865be1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/492/Recreation-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12363141999986564857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-recreation-center",
      "poi_latitude": "40.2418019",
      "poi_longitude": "-111.6643957",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-852-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU8vNVKiQTYcR-V7pcCW0kqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_d81fbb6c-2075-4e3f-826d-62b272590f9a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Lakeshore Bridge Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "488 Lakeshore Dr, Provo, UT 84601, USA",
      "poi_short_description": "Peaceful riverside hiking and biking area featuring picnic spots, playgrounds, and well-maintained trail facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-edd3-7430-839f-74edac22fdae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-edd3-7430-839f-74edac22fdae",
        "storage_key": "property/6767906449167908/01a19d93-edd3-7430-839f-74edac22fdae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.provo.org/departments/parks/trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=10696904966888318998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeshore-bridge-trailhead",
      "poi_latitude": "40.2399689",
      "poi_longitude": "-111.7119247",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-852-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d94-17f0-771e-afbe-d065ef4abe90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a19d94-17f0-771e-afbe-d065ef4abe90",
        "storage_key": "property/6767906449167908/01a19d94-17f0-771e-afbe-d065ef4abe90.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyMMYjOaTYcRFmh9i2QKc5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_10eaabe8-7a5e-4fe6-9d67-9486f2e71bd8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Utah Lake State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4400 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "Reserve encompassing Utah's largest freshwater lake, with fishing, boating & camping access.",
      "poi_long_description": "Reserve encompassing Utah's largest freshwater lake, with fishing, boating & camping access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-773e-778a-a96e-a2510384eac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-773e-778a-a96e-a2510384eac4",
        "storage_key": "property/6767906449167908/01a17e46-773e-778a-a96e-a2510384eac4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stateparks.utah.gov/parks/utah-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=811531692525701438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utah-lake-state-park",
      "poi_latitude": "40.2378421",
      "poi_longitude": "-111.7362163",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3_927sGbTYcRPkn3UMYjQws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_423765b2-9f49-487e-a9eb-9002b460857f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Riverview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4620 N 300 W, Provo, UT 84604, USA",
      "poi_short_description": "Expansive park with playgrounds and walking paths, featuring tennis and pickleball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-8705-759d-8800-cbd5ea3eafe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-8705-759d-8800-cbd5ea3eafe7",
        "storage_key": "property/6767906449167908/01a17e48-8705-759d-8800-cbd5ea3eafe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11704463083032005591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-park",
      "poi_latitude": "40.2944787",
      "poi_longitude": "-111.6656194",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-852-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAlAqQTYcR18vLPimbbqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b082527c-7a52-4a5c-b72f-e66c5d01248c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Exchange Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 700 W, Provo, UT 84604, USA",
      "poi_short_description": "Scenic riverside park offering expansive green space, a playground, and trail access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-ef41-7169-8d16-fbbf209e4873.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-ef41-7169-8d16-fbbf209e4873",
        "storage_key": "property/6767906449167908/01a19d93-ef41-7169-8d16-fbbf209e4873.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10849890376814026333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exchange-park",
      "poi_latitude": "40.2472013",
      "poi_longitude": "-111.670983",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-852-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSX67guaTYcRXd7tAdCNkpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db5630ea-a01d-4721-9735-d101dd1772bf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "North Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 N 500 W, Provo, UT 84604, USA",
      "poi_short_description": "Historic city park featuring diverse playground equipment and shaded picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f2ba-7455-9ba1-02bb23c3845b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f2ba-7455-9ba1-02bb23c3845b",
        "storage_key": "property/6767906449167908/01a19d93-f2ba-7455-9ba1-02bb23c3845b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=293087147220822900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-park",
      "poi_latitude": "40.2407189",
      "poi_longitude": "-111.6664406",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-852-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5STkfgeaTYcRdGtUIjVBEQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b96970d5-0a28-41fd-9e10-5e721229ce3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Paul Ream Wilderness Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 500 N, Provo, UT 84601, USA",
      "poi_short_description": "Riverside park & picnic spot with a duck pond, covered pavilions, grassy areas & a playground.",
      "poi_long_description": "Riverside park & picnic spot with a duck pond, covered pavilions, grassy areas & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-7a38-712c-aaaf-97809c2ba55c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-7a38-712c-aaaf-97809c2ba55c",
        "storage_key": "property/6767906449167908/01a17e48-7a38-712c-aaaf-97809c2ba55c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4769019561224862893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-ream-wilderness-park",
      "poi_latitude": "40.2413279",
      "poi_longitude": "-111.685227",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-852-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8ekDxeaTYcRrXyyCQb2LkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fb3dd43e-41f8-4857-bbc3-6e4ad477c60c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Rock Canyon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Rock Canyon Park, 2620 N 1200 E, Provo, UT 84604, USA",
      "poi_short_description": "Sprawling green space with a trail & playgrounds, plus a volleyball court, horseshoes & disc golf.",
      "poi_long_description": "Sprawling green space with a trail & playgrounds, plus a volleyball court, horseshoes & disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-79a7-76c9-9ac5-39e9fdee5d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-79a7-76c9-9ac5-39e9fdee5d18",
        "storage_key": "property/6767906449167908/01a17e46-79a7-76c9-9ac5-39e9fdee5d18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=5695647605713341656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-canyon-park",
      "poi_latitude": "40.267193600000006",
      "poi_longitude": "-111.6356342",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-852-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYyDHYe6QTYcR2AxZEFIBC08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ba0b0cd0-7c71-4a4e-9e7a-a6d997af5d43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1260 West 600 North, Provo, UT 84601, USA",
      "poi_short_description": "Scenic city park featuring a playground and picnic areas along the river trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f34b-744b-953e-4fb6e7e0ebfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f34b-744b-953e-4fb6e7e0ebfb",
        "storage_key": "property/6767906449167908/01a19d93-f34b-744b-953e-4fb6e7e0ebfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=14058527906738825359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "40.2423654",
      "poi_longitude": "-111.6807177",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-852-6006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFeQ7iBCaTYcRj2gVWqXsGcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_36e0a303-7fca-4a8f-b5f8-a5727b907790",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "The Rivers Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2844 W 230 N, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-8895-70cc-a849-6d93187504ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-8895-70cc-a849-6d93187504ef",
        "storage_key": "property/6767906449167908/01a17e48-8895-70cc-a849-6d93187504ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://provo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9965605577739245115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rivers-natural-area",
      "poi_latitude": "40.2373075",
      "poi_longitude": "-111.7081958",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-852-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_R1L7ubTYcRO5bMEHnxTIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7c18cb9-7ef0-48e0-9dbb-f7a08cab073a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Lions Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 W 1280 N St, Provo, UT 84604, USA",
      "poi_short_description": "Charming city park offering a variety of athletic amenities, pavilions & picturesque walking trails.",
      "poi_long_description": "Charming city park offering a variety of athletic amenities, pavilions & picturesque walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f2d9-7437-8fff-089c1c4a03cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f2d9-7437-8fff-089c1c4a03cb",
        "storage_key": "property/6767906449167908/01a19d93-f2d9-7437-8fff-089c1c4a03cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.gov/353/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9286753309256279342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lions-park",
      "poi_latitude": "40.250323",
      "poi_longitude": "-111.676134",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-852-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-94c2-7462-8067-92648712d6a9",
        "storage_key": "property/6767906449167908/01a17e46-94c2-7462-8067-92648712d6a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1HLSQ2aTYcRLmXncu4s4YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8f28a804-ce6c-4287-bfa1-40e4ec2f3809",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 S Freedom Blvd, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-8c73-759b-818a-dcd2c516f3a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-8c73-759b-818a-dcd2c516f3a3",
        "storage_key": "property/6767906449167908/01a17e48-8c73-759b-818a-dcd2c516f3a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10644768553655109905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-central-station",
      "poi_latitude": "40.2251126",
      "poi_longitude": "-111.6613494",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-743-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPa-oZHSXTYcREYnc5JnQuZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_2cb11982-838e-4370-8c49-52f890f5cb3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "300 W 600 S, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-8e1e-7110-bb18-7fa6f21dca28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-8e1e-7110-bb18-7fa6f21dca28",
        "storage_key": "property/6767906449167908/01a17e48-8e1e-7110-bb18-7fa6f21dca28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7981491824337896854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-amtrak-station",
      "poi_latitude": "40.2258721",
      "poi_longitude": "-111.6639957",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-833-0085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af2-7439-a8bc-bec8e2c340f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af2-7439-a8bc-bec8e2c340f0",
        "storage_key": "property/6767906449167908/01a17e48-9af2-7439-a8bc-bec8e2c340f0.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQUjl1eXTYcRlkVYx4b0w24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_53460f1c-8f2e-410b-856d-c0b341401142",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Towne Centre",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 Towne Centre Blvd, Provo, UT 84601, USA",
      "poi_short_description": "Department stores anchor this enclosed mall with smaller chains, dining options & a movie theater.",
      "poi_long_description": "Department stores anchor this enclosed mall with smaller chains, dining options & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f198-7721-8a2a-88577cf48b62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f198-7721-8a2a-88577cf48b62",
        "storage_key": "property/6767906449167908/01a19d93-f198-7721-8a2a-88577cf48b62.webp",
        "width": 979,
        "height": 651
      },
      "poi_business_url": "https://www.provotownecentre.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=3393",
      "poi_directions_map_url": "https://maps.google.com/?cid=5962888526803586084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-towne-centre",
      "poi_latitude": "40.217178",
      "poi_longitude": "-111.66298",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-852-2401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9071-719e-bdca-92b20e902f52",
        "storage_key": "property/6767906449167908/01a17e46-9071-719e-bdca-92b20e902f52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8c41NF6XTYcRJExhu4VvwFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_78ab8459-066a-4d1e-bb53-1c958389408d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "UTA Orem Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1350 W 900 S, Orem, UT 84058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f855-764f-a3b9-4f27b83fa821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f855-764f-a3b9-4f27b83fa821",
        "storage_key": "property/6767906449167908/01a19d93-f855-764f-a3b9-4f27b83fa821.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rideuta.com/Rider-Tools/Schedules-and-Maps/750-FrontRunner",
      "poi_directions_map_url": "https://maps.google.com/?cid=6717252479156080271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uta-orem-central-station",
      "poi_latitude": "40.2809442",
      "poi_longitude": "-111.7262729",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1P5E06FTYcRj861Top5OF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_0cde5ec6-db4a-4327-89ff-757d90859e8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "BYU Stadium Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f3fc-7159-b4e9-e1718a0906f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f3fc-7159-b4e9-e1718a0906f3",
        "storage_key": "property/6767906449167908/01a19d93-f3fc-7159-b4e9-e1718a0906f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3187302834891256459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byu-stadium-station",
      "poi_latitude": "40.255859",
      "poi_longitude": "-111.652053",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af3-7326-9941-28d1b12e43c0",
        "storage_key": "property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ004Ob72QTYcRi_JJkQqTOyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_86b1c9dc-74a3-4882-acb1-c3fd57182aed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Center Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4405954755840994647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-street-station",
      "poi_latitude": "40.233345",
      "poi_longitude": "-111.658694",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af0-72fd-bfbb-c89461fdcf59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af0-72fd-bfbb-c89461fdcf59",
        "storage_key": "property/6767906449167908/01a17e48-9af0-72fd-bfbb-c89461fdcf59.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbISdVOXTYcRV21YtoEYJT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1add59b5-5cc7-45a8-b4f9-601df4a587ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orem, UT 84058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f8a3-7543-aeae-2abc1e409977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f8a3-7543-aeae-2abc1e409977",
        "storage_key": "property/6767906449167908/01a19d93-f8a3-7543-aeae-2abc1e409977.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16113486668491118924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-station",
      "poi_latitude": "40.273504",
      "poi_longitude": "-111.694648",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af3-7326-9941-28d1b12e43c0",
        "storage_key": "property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZ5r7POaTYcRTNlniMCant8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_fb178f8f-c952-411d-9a58-ac0d3181379f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "East Bay South Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Provo, UT 84606, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d93-f84c-72dc-9c5f-407fbe0ed6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d93-f84c-72dc-9c5f-407fbe0ed6ce",
        "storage_key": "property/6767906449167908/01a19d93-f84c-72dc-9c5f-407fbe0ed6ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1474467250005351648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-bay-south-station",
      "poi_latitude": "40.208943",
      "poi_longitude": "-111.655214",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af3-7326-9941-28d1b12e43c0",
        "storage_key": "property/6767906449167908/01a17e48-9af3-7326-9941-28d1b12e43c0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRNvbmWXTYcR4ByE3SZcdhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_50848a76-fdc7-4e39-aafa-99dffd05699b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo/Orem Exit 263 UT",
      "poi_type": "Transportation & Transit",
      "poi_address": "Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2927419336158409837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provoorem-exit-263-ut",
      "poi_latitude": "40.223909",
      "poi_longitude": "-111.661288",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9af0-72fd-bfbb-c89461fdcf59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e48-9af0-72fd-bfbb-c89461fdcf59",
        "storage_key": "property/6767906449167908/01a17e48-9af0-72fd-bfbb-c89461fdcf59.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99G7llmXTYcRbfRUSGBIoCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_77dbbe24-365d-4239-b4c0-25a7f4871d3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Nu Skin Enterprises",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-83c0-717a-8723-d6b2c1b8700e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e46-83c0-717a-8723-d6b2c1b8700e",
        "storage_key": "property/6767906449167908/01a17e46-83c0-717a-8723-d6b2c1b8700e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nuskin.com/us/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11933797479477019330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nu-skin-enterprises",
      "poi_latitude": "40.2332835",
      "poi_longitude": "-111.6602541",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-345-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-T4f1SXTYcRwgKuYZRdnaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d68a8619-3327-449e-8765-7819c1b2dff9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Qualtrics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 W River Park Dr, Provo, UT 84604, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9071-72db-a74a-356a7200ddaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-9071-72db-a74a-356a7200ddaa",
        "storage_key": "property/6767906449167908/01a17e48-9071-72db-a74a-356a7200ddaa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.qualtrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=343777111390112491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qualtrics",
      "poi_latitude": "40.303006",
      "poi_longitude": "-111.663392",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 385-585-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3dPRgiQTYcR60pRHnZXxQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_61437bbe-35fa-4a9e-ba9f-e7b5869c4d51",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "445 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-938f-76f1-a9ce-5cf424fa965e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-938f-76f1-a9ce-5cf424fa965e",
        "storage_key": "property/6767906449167908/01a17e48-938f-76f1-a9ce-5cf424fa965e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.provo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13897472726629982124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-city-hall",
      "poi_latitude": "40.2333887",
      "poi_longitude": "-111.6669803",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-852-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9510-70fc-8a8b-6fa2df29f4fd",
        "storage_key": "property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cTDQVWXTYcRrJ91GtC93cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_07d4e69c-ed9a-4fe4-b7e8-b54cfc685c98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Utah County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Center St, Provo, UT 84606, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-9391-70cb-9cbe-4ad52bdd62a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-9391-70cb-9cbe-4ad52bdd62a8",
        "storage_key": "property/6767906449167908/01a17e48-9391-70cb-9cbe-4ad52bdd62a8.webp",
        "width": 704,
        "height": 608
      },
      "poi_business_url": "https://www.utahcounty.gov/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=2128330630667460178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utah-county-administration-building",
      "poi_latitude": "40.2331007",
      "poi_longitude": "-111.6572494",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-851-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9510-70fc-8a8b-6fa2df29f4fd",
        "storage_key": "property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJe9atVOXTYcRUl6EpW5ZiR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_f03b5034-a340-4569-ac8f-9ba72041d325",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Vivint",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4949 N 300 W, Provo, UT 84604, USA",
      "poi_short_description": "Comprehensive smart home security provider featuring remote system management via mobile app.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-901b-72fe-a538-06e6e3d3905a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17e48-901b-72fe-a538-06e6e3d3905a",
        "storage_key": "property/6767906449167908/01a17e48-901b-72fe-a538-06e6e3d3905a.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.vivint.com/locations/utah/provo?exid=205568&tfn=801.506.6182",
      "poi_directions_map_url": "https://maps.google.com/?cid=3943606492811834270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vivint",
      "poi_latitude": "40.3001948",
      "poi_longitude": "-111.6637115",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-506-6182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9082-753b-90df-88a686c83789",
        "storage_key": "property/6767906449167908/01a17e46-9082-753b-90df-88a686c83789.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68EjCwmQTYcRnjP5CTaBujY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_a3cc0de8-3e99-4652-b17d-c1ce436628e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "poi_name": "Provo Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "445 W Center St, Provo, UT 84601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a19d94-0113-76ee-b48c-ca4ddbd30722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a19d94-0113-76ee-b48c-ca4ddbd30722",
        "storage_key": "property/6767906449167908/01a19d94-0113-76ee-b48c-ca4ddbd30722.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.provo.gov/283/Police",
      "poi_directions_map_url": "https://maps.google.com/?cid=13841265578419295937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "provo-police-department",
      "poi_latitude": "40.2333887",
      "poi_longitude": "-111.6669803",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-852-6210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17e46-9510-70fc-8a8b-6fa2df29f4fd",
        "storage_key": "property/6767906449167908/01a17e46-9510-70fc-8a8b-6fa2df29f4fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TxZEFWXTYcRwRaGm7UNFsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_683438024aa8868edefb629e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0256385c5f0b3f6c885bcd5d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f7b6bc8d1f5d20db0ae035a0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c1a9f58b60759bcd8a459769",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ddc3f5bca5a58a62bce52d5e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4369fb512c919d132a22f468",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fd170f401a43b984502478c1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "rating": "5",
      "name": "Kaylynn Seely",
      "text": "Savanah is great to work with! She’s so friendly and knowledgeable! I would definitely rent a place with her!",
      "date": "2026-06-18",
      "title": "false"
    },
    {
      "id": "ec_14d6624003c2c27e8ad92884",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "rating": "5",
      "name": "cameron wimmer",
      "text": "Such a beautiful property with a leasing and maintenance team who all truly care about their residents and their experience there. Loved my time spent at Towns at River's Edge! 🫶🏼",
      "date": "2026-01-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_7085bdf59c76e8611a1353d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-fa64-7388-87aa-6a1982faf5fc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e48-fa64-7388-87aa-6a1982faf5fc",
        "storage_key": "property/6767906449167908/01a17e48-fa64-7388-87aa-6a1982faf5fc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,057SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=atgHqWc6wWX"
    },
    {
      "id": "ec_d0d41c1e480b2b72d2cd80b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-fc92-70ef-9d99-15d500f27596.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e48-fc92-70ef-9d99-15d500f27596",
        "storage_key": "property/6767906449167908/01a17e48-fc92-70ef-9d99-15d500f27596.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 735SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ux4A7RLyiwo"
    },
    {
      "id": "ec_d10c922e30d0e62a105e3047",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-f60b-75bb-a7b9-7fadb7603c91.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e48-f60b-75bb-a7b9-7fadb7603c91",
        "storage_key": "property/6767906449167908/01a17e48-f60b-75bb-a7b9-7fadb7603c91.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Yuba 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NwRCM88bxEn"
    },
    {
      "id": "ec_670b22d61590d207d940b913",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e49-11cd-76c8-b4ee-b6b5e0e00832.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e49-11cd-76c8-b4ee-b6b5e0e00832",
        "storage_key": "property/6767906449167908/01a17e49-11cd-76c8-b4ee-b6b5e0e00832.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Aspen 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3UuLWVuhXur"
    },
    {
      "id": "ec_e7536b15f1e8edcef4b4fe09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e48-f548-738f-b4fa-de710afe05d2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e48-f548-738f-b4fa-de710afe05d2",
        "storage_key": "property/6767906449167908/01a17e48-f548-738f-b4fa-de710afe05d2.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Stillwater 2x2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CoXUz2rd59t"
    },
    {
      "id": "ec_49591643b06b479102507cb9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167908/01a17e49-23e8-7560-bffc-50f807baa855.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17e49-23e8-7560-bffc-50f807baa855",
        "storage_key": "property/6767906449167908/01a17e49-23e8-7560-bffc-50f807baa855.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Juniper 2x2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=f8pbyLFzJ6J"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a1a36c-c209-7068-a531-8014a4e06af2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Rivers Edge Townhomes & Lofts Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-provo-ut",
      "search_query": "luxury apartments with pool Provo UT",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Provo, UT",
      "h2_subtitle": "Experience true indulgence at our luxury apartments with a pool in Provo, UT. Discover unparalleled amenities and breathtaking river views.",
      "page_copy": "Welcome to Towns at River's Edge and Lofts at Rivers Edge, where luxury meets convenience in the heart of Provo, UT. Our community offers an exquisite selection of studio to four-bedroom floor plans, catering to those seeking style and comfort. Indulge yourself with our open-concept designs, premium finishes, and stunning mountain views. \n\nDive into relaxation by our sparkling pool, a perfect escape for unwinding after a busy day. Our prime location along the Provo River provides not only picturesque landscape but also close proximity to local attractions and amenities. With attached and detached garage options, smart home features, and in-home laundry, you'll find everything you need to embrace modern Provo living. Schedule a tour today and discover what makes our luxury apartments with a pool in Provo, UT, truly exceptional.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Provo, UT",
      "seo_description": "Discover luxury living in Provo, UT. Explore our apartments with a pool, stunning mountain views, and prime riverside location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-riverside-provo",
      "search_query": "apartments with in-unit laundry Riverside Provo",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Riverside Provo",
      "h2_subtitle": "Discover our Riverside Provo apartments with in-unit laundry and modern amenities. Experience the convenience today!",
      "page_copy": "Towns at River's Edge and Lofts at Rivers Edge present an amazing living experience in Riverside, Provo. Enjoy the convenience of in-unit laundry in our thoughtfully designed studio to four-bedroom apartments. Nestled against the Provo River, our community combines mountain views with city life. \n\nStep into elegant interiors featuring polished finishes and open-concept spaces perfect for relaxation and entertainment alike. Along with in-unit laundry, residents benefit from attached and detached garage options, stunning sightlines of the surrounding mountains, and cutting-edge smart home features. Embrace the lifestyle that's waiting for you here in Riverside, Provo, complete with the comforts and convenience you're looking for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Riverside Provo",
      "seo_description": "Explore Riverside Provo apartments with in-unit laundry, open floor plans, and prime location by Provo River. Experience convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-apartments-scenic-mountain-views",
      "search_query": "Provo apartments with scenic mountain views",
      "category": "Amenity",
      "h1_title": "Provo Apartments with Scenic Mountain Views",
      "h2_subtitle": "Bask in the beauty of Provo apartments with scenic mountain views. Enjoy picturesque living by the river and modern amenities.",
      "page_copy": "Towns at River's Edge and Lofts at Rivers Edge offer a truly unique living experience in Provo, featuring breathtaking scenic mountain views. Our range of studio to four-bedroom apartments provides the perfect backdrop for those who appreciate nature's beauty amidst urban living. Located along the Provo River, our community ensures residents are enveloped in both tranquility and convenience.\n\nOur open-concept floor plans boast contemporary finishes, smart home technology, and in-home laundry facilities, making everyday life both comfortable and efficient. With options for attached and detached garages, our apartments cater to a variety of needs, ensuring an ideal environment. Come immerse yourself in the stunning vistas and explore why our Provo apartments with scenic mountain views are the place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo Apartments with Scenic Mountain Views",
      "seo_description": "Discover Provo apartments with scenic mountain views and modern amenities by the river. Experience serene living with stunning landscapes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-county-apartments-fitness-center",
      "search_query": "Provo County apartments state-of-the-art fitness center",
      "category": "Amenity",
      "h1_title": "Provo County Apartments with Fitness Center",
      "h2_subtitle": "Explore Provo County apartments with a state-of-the-art fitness center. Stay fit and live well in a modern community with exceptional amenities.",
      "page_copy": "At Towns at River's Edge and Lofts at Rivers Edge, residents enjoy access to a state-of-the-art fitness center, ensuring you can maintain your active lifestyle right at home. Located in Provo County, our community is the ideal choice for those seeking wellness and comfort in a sophisticated setting. With spacious studio to four-bedroom floor plans, there’s a perfect fit for everyone.\n\nOur Provo County apartments are more than just a place to live; they are a haven of convenience and modernity, featuring smart home features, in-home laundry, and stunning mountain views. Alongside our fitness center, enjoy the advantage of living by the Provo River with nearby recreational activities, creating a balanced and health-focused environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo County Apartments with Fitness Center",
      "seo_description": "Find Provo County apartments with a state-of-the-art fitness center, modern amenities, and beautiful views. Live healthy and comfortable.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "smart-home-technology-apartments-utah-county",
      "search_query": "smart home technology apartments Utah County",
      "category": "Amenity",
      "h1_title": "Smart Home Technology Apartments in Utah County",
      "h2_subtitle": "Enjoy modern living with smart home technology in Utah County. Discover the convenience and innovation at our apartment community.",
      "page_copy": "Experience cutting-edge living at Towns at River's Edge and Lofts at Rivers Edge, where smart home technology meets comfortable living in Utah County. Our range of studio to four-bedroom apartments is designed with the modern resident in mind, offering intelligent solutions for daily life.\n\nNestled in a prime location by the Provo River, our community features smart home enhancements, in-home laundry, and open-concept floor plans. Not only will you enjoy scenic mountain views, but also a seamless living experience enhanced by technology. Embrace the ease and efficiency of life in Utah County's premiere smart home technology apartments and upgrade your lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Technology Apartments in Utah County",
      "seo_description": "Discover Utah County apartments with smart home technology. Enjoy innovative living with modern amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "studio-apartments-provo-ut",
      "search_query": "studio apartments Provo UT",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Provo, UT",
      "h2_subtitle": "Discover spacious studio apartments in Provo, UT. Enjoy modern comfort, scenic views, and convenience at Towns at River's Edge.",
      "page_copy": "Looking for a cozy yet modern studio apartment in Provo, UT? Towns at River's Edge and Lofts at Rivers Edge offer beautifully designed studio residences that blend comfort and style. Situated in a prime location along the Provo River, our community provides breathtaking mountain views, perfect for those seeking tranquility and urban convenience.\n\nOur studio apartments boast open-concept layouts with smart home technology, in-home laundry, and high-end finishes. Whether you’re working from home or enjoying the nearby outdoor activities, our Provo studio apartments cater to all lifestyles, offering a perfect balance of efficiency and elegance. Discover the ideal living space in the heart of Utah County today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Provo, UT",
      "seo_description": "Explore modern studio apartments in Provo, UT, with stunning views and convenient amenities. Ideal for comfortable and stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-riverside-provo",
      "search_query": "one bedroom apartments Riverside Provo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Riverside, Provo",
      "h2_subtitle": "Find your ideal one bedroom apartment in Riverside, Provo. Enjoy comfortable living with mountain views and modern amenities.",
      "page_copy": "Nestled in the Riverside neighborhood of Provo, Towns at River's Edge and Lofts at Rivers Edge offer exceptional one bedroom apartments that combine modern sophistication with serene living. These thoughtfully designed residences provide everything you need for a comfortable lifestyle, including smart home features and in-home laundry.\n\nEnjoy the benefits of living near the Provo River, with scenic mountain views and easy access to local attractions. Our one bedroom apartments in Riverside, Provo boast open-concept layouts, providing ample space and natural light. Embrace the perfect blend of practicality and elegance in a vibrant community waiting for you to call it home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Riverside, Provo",
      "seo_description": "Discover one bedroom apartments in Riverside, Provo, offering modern living with scenic views and smart home features. Perfect for a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "two-bedroom-townhomes-utah-county",
      "search_query": "two bedroom townhomes Utah County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Utah County",
      "h2_subtitle": "Explore two bedroom townhomes in Utah County for modern living. Featuring spacious layouts and convenient amenities near Provo River.",
      "page_copy": "Discover the comfort and style of two bedroom townhomes at Towns at River's Edge and Lofts at Rivers Edge in Utah County. These homes offer spacious, open-concept floor plans perfect for accommodating families or individuals seeking modern convenience. Enjoy the blend of practicality and elegance with features like in-home laundry and smart home technology.\n\nLocated near the picturesque Provo River, our townhomes provide stunning mountain views and a prime setting in Utah County. With attached and detached garage options and easy access to local amenities, these two bedroom townhomes are designed for those who value both space and location. Experience the best of townhome living in a vibrant community that feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes in Utah County",
      "seo_description": "Find spacious two bedroom townhomes in Utah County, offering modern amenities, smart home features, and stunning views near Provo River.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "three-bedroom-flats-near-84604",
      "search_query": "three bedroom flats near 84604",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Flats Near 84604",
      "h2_subtitle": "Discover spacious three bedroom flats near 84604. Enjoy modern amenities and stunning views at Towns at River's Edge.",
      "page_copy": "Experience the perfect blend of comfort and style in our three bedroom flats near the 84604 area at Towns at River's Edge and Lofts at Rivers Edge. These expansive homes are designed with families and those who need a bit more space in mind, featuring open-concept layouts and high-end finishes. Situated in a highly desirable location along the Provo River, enjoy majestic mountain views and easy access to all that Provo has to offer.\n\nOur three bedroom flats come equipped with smart home technology and in-home laundry, making everyday living convenient and efficient. With options for attached and detached garages, these flats offer the ideal living arrangement for those seeking both tranquility and accessibility. Find your home in a welcoming community that prioritizes style and functionality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Flats Near 84604",
      "seo_description": "Explore three bedroom flats near the 84604 area with modern amenities, smart home features, and scenic views at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "four-bedroom-apartments-provo-ut",
      "search_query": "four bedroom apartments in Provo UT",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Provo, UT",
      "h2_subtitle": "Explore spacious four bedroom apartments in Provo, UT. Perfect for families or roommates seeking modern living with scenic views.",
      "page_copy": "At Towns at River's Edge and Lofts at Rivers Edge, discover the perfect four bedroom apartments in Provo, UT, designed for comfort and convenience. Ideal for larger families or groups of roommates, these expansive apartments offer open-concept living spaces, smart home features, and in-home laundry facilities.\n\nSituated along the picturesque Provo River, these apartments provide breathtaking mountain views and a serene setting. Enjoy the added convenience of attached and detached garage options. Living in Provo's vibrant community offers easy access to city amenities while maintaining the peace of riverside living. Make the move today to a home that combines modern style with functional living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Provo, UT",
      "seo_description": "Find spacious four bedroom apartments in Provo, UT, with modern amenities and stunning views at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-near-canyon-crest-elementary-school",
      "search_query": "apartments near Canyon Crest Elementary School in Riverside",
      "category": "School",
      "h1_title": "Apartments Near Canyon Crest Elementary School",
      "h2_subtitle": "Discover modern apartments near Canyon Crest Elementary School in Riverside. A perfect mix of amenities and a family-friendly atmosphere.",
      "page_copy": "Explore a variety of modern living options at Towns at River's Edge and Lofts at Rivers Edge, conveniently located near Canyon Crest Elementary School in the Riverside neighborhood. Our community offers a selection of studio to four-bedroom apartments with polished finishes and smart home technology, ideal for families seeking proximity to quality education.\n\nNestled by the Provo River, these apartments provide not only scenic mountain views but also enhance everyday living with practical amenities such as in-home laundry and air conditioning. Enjoy peace of mind with garage options and the vibrant community atmosphere Riverside offers. Choose a home that supports both family life and modern comfort. Schedule a tour today and see it all for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Canyon Crest Elementary School",
      "seo_description": "Find apartments near Canyon Crest Elementary School with modern amenities and family-friendly features at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-by-centennial-middle-school-provo",
      "search_query": "apartments by Centennial Middle School Provo UT",
      "category": "School",
      "h1_title": "Apartments by Centennial Middle School",
      "h2_subtitle": "Find ideal apartments by Centennial Middle School in Provo, UT. Experience modern living with convenience and style in a prime location.",
      "page_copy": "Discover the convenience of living near Centennial Middle School at Towns at River's Edge and Lofts at Rivers Edge. Situated in Provo, UT, these apartments offer an exceptional combination of modern amenities and a family-friendly environment. Perfect for families and individuals alike, our homes feature open-concept layouts, smart home integrations, and in-home laundry facilities.\n\nNestled alongside the Provo River, residents can enjoy stunning mountain vistas and a serene atmosphere, all while being just minutes from Centennial Middle School. The community also offers a selection of attached and detached garages, providing the flexibility and convenience you need. Explore the vibrant Riverside area and find your perfect home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Centennial Middle School",
      "seo_description": "Explore apartments near Centennial Middle School in Provo with modern features and a convenient location at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-rentals-near-rock-canyon-elementary",
      "search_query": "Provo rentals close to Rock Canyon Elementary School",
      "category": "School",
      "h1_title": "Provo Rentals Near Rock Canyon Elementary",
      "h2_subtitle": "Explore rentals close to Rock Canyon Elementary School in Provo. Ideal for families seeking modern amenities and a vibrant community.",
      "page_copy": "Discover exceptional Provo rentals close to Rock Canyon Elementary School at Towns at River's Edge and Lofts at Rivers Edge. These properties offer an ideal setting for families with children attending nearby schools, providing both comfort and convenience. Choose from a variety of floor plans, ranging from studios to spacious four-bedroom options, all featuring polished finishes and smart home technology.\n\nLocated along the scenic Provo River, these rentals not only boast picturesque mountain views but also include practical amenities like in-home laundry and air conditioning. Whether you need an attached or detached garage option, our community offers flexibility and comfort. Embrace modern living in a family-friendly environment and explore Riverside's vibrant surroundings today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo Rentals Near Rock Canyon Elementary",
      "seo_description": "Find rentals near Rock Canyon Elementary in Provo with modern amenities and family-oriented features at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "townhomes-near-timpview-high-school-riverside",
      "search_query": "townhomes near Timpview High School in Riverside",
      "category": "School",
      "h1_title": "Townhomes Near Timpview High School",
      "h2_subtitle": "Discover townhomes near Timpview High School in Riverside. Experience comfort and style just moments from this premier Provo high school.",
      "page_copy": "Explore the unmatched location of Towns at River's Edge and Lofts at Rivers Edge, offering modern townhomes near Timpview High School. Located in the heart of Riverside, this community is perfect for families and individuals seeking proximity to education and recreation alike. Each residence is designed with contemporary aesthetics, featuring open-concept spaces, in-home laundry, and smart home features that meet the needs of modern living.\n\nEnjoy breathtaking mountain views and the tranquility of the Provo River from your doorstep. Our townhomes offer both attached and detached garage options, providing additional convenience. Whether you're catching a game at Timpview High or exploring the Riverside neighborhood, the location supports an active and vibrant lifestyle. Schedule a tour today to see these beautiful homes in person.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Timpview High School",
      "seo_description": "Explore Riverside townhomes near Timpview High School with modern features and family-friendly amenities at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-apartments-near-provo-high-school",
      "search_query": "Provo UT apartments by Provo High School",
      "category": "School",
      "h1_title": "Provo Apartments by Provo High School",
      "h2_subtitle": "Find premium Provo apartments close to Provo High School. Enjoy modern living with convenient access to educational and recreational facilities.",
      "page_copy": "Welcome to Towns at River's Edge and Lofts at Rivers Edge, where you can find exceptional Provo apartments just minutes from Provo High School. Ideal for students and families, this community provides a seamless blend of convenience, comfort, and style. Our floor plans range from studios to four-bedroom options, all featuring high-end finishes and essential amenities like in-home laundry and air conditioning.\n\nNestled in a prime location by the Provo River in Riverside, these apartments offer stunning mountain views and easy access to both nature and city life. Residents can select from attached or detached garages, adding flexibility to daily living. Whether you're heading to school, work, or exploring the local area, these apartments offer an ideal launching point. Discover modern living with close proximity to educational facilities today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo Apartments by Provo High School",
      "seo_description": "Discover modern Provo apartments near Provo High School with outstanding amenities at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-near-franklin-school-utah-county",
      "search_query": "apartments near Franklin School Utah County",
      "category": "School",
      "h1_title": "Apartments Near Franklin School Utah County",
      "h2_subtitle": "Explore apartments close to Franklin School in Utah County. Enjoy a perfect mix of convenience and comfort near educational institutions.",
      "page_copy": "At Towns at River's Edge and Lofts at Rivers Edge, you can find beautifully designed apartments near Franklin School in Utah County. These residences offer the perfect location for families seeking proximity to quality education without sacrificing modern comforts. Choose from a variety of floor plans, including studio to four-bedroom options, all equipped with smart home features and polished finishes.\n\nSituated along the scenic Provo River in the Riverside neighborhood, our community provides a tranquil setting complemented by breathtaking mountain views. Enjoy the convenience of attached and detached garage choices, and relish in amenities like in-home laundry and air conditioning. Whether you’re here for the schools or the stunning outdoor activities, these apartments deliver a premium living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Franklin School, Utah County",
      "seo_description": "Find convenient and comfortable apartments near Franklin School, Utah County. Offered by Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-rentals-near-wasatch-elementary-school",
      "search_query": "Provo rentals close to Wasatch Elementary School",
      "category": "School",
      "h1_title": "Provo Rentals Near Wasatch Elementary",
      "h2_subtitle": "Discover Provo rentals close to Wasatch Elementary School, offering comfort and access to top educational facilities in a family-friendly community.",
      "page_copy": "Welcome to Towns at River's Edge and Lofts at Rivers Edge, where you will find superb Provo rentals close to Wasatch Elementary School. This prime location in the Riverside neighborhood caters to families who value educational access coupled with modern living amenities. Choose from a variety of residences, from cozy studios to spacious four-bedroom homes, all featuring smart home capabilities and elegant finishes.\n\nEnjoy breathtaking mountain views and the convenience of the Provo River location, making commuting and exploring Provo a breeze. With options like attached and detached garages, in-home laundry, and air conditioning, these rentals offer unmatched comfort and practicality. Experience the peace of mind that comes with living near quality schools while enjoying all the features of contemporary apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo Rentals Near Wasatch Elementary",
      "seo_description": "Find comfortable Provo rentals near Wasatch Elementary School with modern amenities at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-near-brigham-young-university",
      "search_query": "apartments near Brigham Young University",
      "category": "School",
      "h1_title": "Apartments Near Brigham Young University",
      "h2_subtitle": "Explore apartments conveniently located near Brigham Young University, offering students and staff modern living with easy campus access.",
      "page_copy": "Discover the perfect living experience at Towns at River's Edge and Lofts at Rivers Edge, featuring contemporary apartments near Brigham Young University. Our community is ideal for students, faculty, and staff who crave a seamless blend of convenience and style close to campus. With options ranging from studios to spacious four-bedroom layouts, each unit is designed with polished finishes and smart home features.\n\nLocated in the serene Riverside neighborhood along the Provo River, these apartments provide easy access to both natural beauty and urban amenities. Enjoy breathtaking mountain views and amenities including in-home laundry, air conditioning, and the choice of attached or detached garages. Whether you're studying, commuting, or enjoying the vibrant local scene, these apartments offer a perfect home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brigham Young University",
      "seo_description": "Find modern apartments near Brigham Young University with excellent amenities at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-close-to-utah-valley-university-84604",
      "search_query": "apartments close to Utah Valley University 84604",
      "category": "School",
      "h1_title": "Apartments Close to Utah Valley University 84604",
      "h2_subtitle": "Explore ideal living spaces close to Utah Valley University (84604). Enjoy modern living with quick access to campus and local amenities.",
      "page_copy": "Towns at River's Edge and Lofts at Rivers Edge offer exceptional apartments close to Utah Valley University, perfect for students and staff seeking a modern, convenient lifestyle. Nestled in the Riverside neighborhood of Provo, these residences provide an excellent combination of accessibility and serene living with views of the Provo River and surrounding mountains.\n\nChoose from various floor plans—from studios to expansive four-bedrooms—with smart home technologies and sophisticated finishes. Our community amenities include in-home laundry, air conditioning, and the flexibility of attached or detached garage options, ensuring comfort and convenience. Whether prioritizing an easy commute or enjoying local entertainment, these apartments cater to all your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Utah Valley University 84604",
      "seo_description": "Find convenient, modern apartments close to Utah Valley University (84604) at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-near-utah-lake-state-park-provo",
      "search_query": "apartments near utah lake state park provo",
      "category": "Park",
      "h1_title": "Apartments Near Utah Lake State Park Provo",
      "h2_subtitle": "Discover apartments perfectly situated near Utah Lake State Park in Provo, offering residents a blend of nature and modern convenience.",
      "page_copy": "Experience the best of both worlds at Towns at River's Edge and Lofts at Rivers Edge, featuring apartments near Utah Lake State Park, Provo. Our community provides an exceptional location for nature enthusiasts who want to balance outdoor adventures with contemporary living amenities. From efficient studios to expansive four-bedroom layouts, our residences are crafted with sleek finishes and smart home technologies.\n\nJust a short drive from scenic Utah Lake State Park, these apartments offer breathtaking views and outdoor accessibility, enhanced by the beauty of the nearby mountains. Residents enjoy in-home laundry facilities, air conditioning, and options for attached or detached garages, ensuring all conveniences are met. Embrace a vibrant lifestyle with direct access to riverside trails and recreational activities, making these apartments the perfect home base for exploration.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Utah Lake State Park Provo",
      "seo_description": "Find modern apartments near Utah Lake State Park in Provo with easy access to outdoor adventures at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "riverside-apartments-close-to-riverview-park-utah",
      "search_query": "riverside apartments close to riverview park utah",
      "category": "Park",
      "h1_title": "Riverside Apartments Close to Riverview Park",
      "h2_subtitle": "Find Riverside apartments conveniently located near Riverview Park, Utah. Enjoy easy access to green spaces and urban amenities.",
      "page_copy": "Welcome to Towns at River's Edge and Lofts at Rivers Edge, where you can find beautiful Riverside apartments close to Riverview Park, Utah. Ideal for those who love nature and convenience, our community offers a serene environment along the Provo River, enhanced by the proximity to Riverview Park.\n\nOur apartments range from cozy studios to spacious four-bedroom layouts, all featuring sophisticated finishes and smart home technologies. Enjoy modern amenities such as in-home laundry, air conditioning, and both attached and detached garage options. With stunning mountain views and the convenience of nearby green spaces, residents can indulge in outdoor activities while enjoying a modern urban lifestyle. Whether you're exploring local trails or relaxing at home, our Riverside apartments offer the perfect balance.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Riverside Apartments Close to Riverview Park Utah",
      "seo_description": "Discover Riverside apartments near Riverview Park, Utah. Experience modern living in a scenic location at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "exchange-park-nearby-apartments-utah-county",
      "search_query": "exchange park nearby apartments in utah county",
      "category": "Park",
      "h1_title": "Apartments Near Exchange Park, Utah County",
      "h2_subtitle": "Explore nearby apartments in Utah County close to Exchange Park. Enjoy modern amenities and scenic surroundings at Towns at River's Edge.",
      "page_copy": "Discover contemporary living at Towns at River's Edge and Lofts at Rivers Edge, where you'll find beautiful apartments near Exchange Park in Utah County. Situated in a prime location, these residences offer the perfect combination of modern amenities and outdoor convenience, ideal for those who value proximity to nature and urban comforts.\n\nOur community provides a range of floor plans, from efficient studios to spacious four-bedroom options, all featuring polished finishes and smart home features. Residents benefit from in-home laundry, air conditioning, and garage options, ensuring a comfortable and convenient lifestyle. With easy access to Exchange Park and the Provo River, enjoy both the tranquility of nature and the vibrancy of city living in Utah County's premier apartment homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Exchange Park, Utah County",
      "seo_description": "Find modern apartments near Exchange Park in Utah County at Towns at River's Edge. Enjoy a perfect blend of nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "lofts-close-to-paul-ream-wilderness-park-provo-ut",
      "search_query": "lofts close to paul ream wilderness park provo ut",
      "category": "Park",
      "h1_title": "Lofts Near Paul Ream Wilderness Park",
      "h2_subtitle": "Discover lofts in Provo, UT, just steps away from Paul Ream Wilderness Park. Embrace nature and modern living combined.",
      "page_copy": "Welcome to Towns at River's Edge and Lofts at Rivers Edge, where contemporary lofts are available just a short distance from Paul Ream Wilderness Park in Provo, UT. Ideal for those who crave the serenity of nature alongside modern conveniences, our community offers a perfect refuge with access to lush landscapes and urban amenities.\n\nOur lofts feature stylish designs and smart home technologies, with open-concept floor plans ranging from intimate studios to expansive four-bedroom options. Residents enjoy amenities such as in-home laundry, air conditioning, and options for garages, providing the ultimate in comfort and practicality. Located near the Provo River and mere minutes from Paul Ream Wilderness Park, our community invites you to explore outdoor adventures while enjoying the sophistication of urban living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Near Paul Ream Wilderness Park Provo UT",
      "seo_description": "Discover modern lofts near Paul Ream Wilderness Park in Provo, UT. Experience nature and urban living at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "apartments-near-the-rivers-natural-area-84604",
      "search_query": "apartments near the rivers natural area 84604",
      "category": "Park",
      "h1_title": "Apartments Near The Rivers Natural Area 84604",
      "h2_subtitle": "Explore apartments in Provo, 84604, near The Rivers Natural Area. Enjoy blends of nature and luxury at Towns at River's Edge.",
      "page_copy": "Welcome to the Towns at River's Edge and Lofts at Rivers Edge, where you'll find exquisite apartments near The Rivers Natural Area in Provo, 84604. Perfect for nature enthusiasts and city dwellers alike, our community offers easy access to natural beauty and modern conveniences in a stunning location.\n\nOur apartments boast open-concept floor plans from studios to four-bedroom units, enhanced with smart home features and polished finishes. Enjoy air conditioning, in-home laundry, and the choice of attached or detached garages. Positioned by the picturesque Provo River and close to The Rivers Natural Area, our community offers the ideal setting for outdoor adventures and stylish living. Experience a lifestyle that seamlessly integrates nature and urban luxury in Provo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Rivers Natural Area 84604",
      "seo_description": "Find beautiful apartments near The Rivers Natural Area in 84604. Experience modern living and natural beauty at Towns at River's Edge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167908",
      "source": "custom",
      "page_item_url": "provo-rentals-near-lions-park-utah",
      "search_query": "provo rentals near lions park utah",
      "category": "Park",
      "h1_title": "Provo Rentals Near Lions Park, Utah",
      "h2_subtitle": "Find rentals in Provo, Utah, close to Lions Park. Enjoy a vibrant community and modern amenities at Towns at River's Edge.",
      "page_copy": "Discover Provo rentals near Lions Park, Utah, at the Towns at River's Edge and Lofts at Rivers Edge, where modern design meets natural beauty. Nestled in a prime location, our community offers residents the perfect balance of tranquility and urban convenience, making it the ideal spot for those seeking a dynamic living experience.\n\nChoose from a range of floor plans, from comfortable studios to expansive four-bedroom residences, all featuring sleek finishes and cutting-edge smart home technologies. Our amenities include in-home laundry, air conditioning, and flexible garage options, ensuring your comfort and convenience. Located near the scenic Provo River and just a short distance from Lions Park, our rentals provide easy access to outdoor recreation and city life, offering the best of both worlds in Provo, Utah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor spa and pool area next to modern building with upper-level balcony seating.",
        "public_id": "01a18981-98fc-72df-aa1e-de1491fca4fa",
        "storage_key": "property/6767906449167908/01a18981-98fc-72df-aa1e-de1491fca4fa.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Provo Rentals Near Lions Park, Utah",
      "seo_description": "Looking for rentals near Lions Park in Provo? Discover modern living at Towns at River's Edge, where amenities meet nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13397578613"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "13397578613",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_audioeye_site_id": "c204e705-22cb-4fd4-9f13-fd3fbdda2d14",
  "custom_audioeye_site_hash": "71742c450373fdf7f257f33a75d72be7"
};

export const generatedAt = '2026-11-03T22:32:25.150Z';
